<template>
  <div v-if="visible" class="details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'|| showBasicInfoForCharge"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <cargo-ag-grid
          v-show="action==='look'"
          :show-side-bar="false"
          :grid-options="gridOptions"
          :row-data="rowData"
          style="min-width: 160px;width:100%;height:100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
        <cargo-ag-grid
          v-if="showBasicInfoForCharge"
          :grid-options="basicInfo.gridOptions"
          :row-data="basicInfo.rowData"
          :show-side-bar="false"
          :check-sub-record="false"
          :check-main-record="false"
          :deselect-main-record="false"
          :deselect-sub-record="false"
          min-height="100%"
          class="section"
          grid-style="min-width: 160px;width:100%;height:100%;"
        />
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers">
              <cargo-button-group-slider ref="cargoButtonGroupSlider">
                <div v-show="action==='look'" :class="'btn-group-look' + (canOperateJob ? '' : ' cannot-operate-job')">
                  <el-button no="1" type="primary" class="can-operate" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <el-button no="2" :disabled="!(job && Number(job.jobState) === 0 && !JobUtils.isBlockJob(job))" type="success" @click="editEventFlag=true">{{ $t('common.btn.edit') }}</el-button>
                  <!--                <el-button type="primary" @click="againShow('add')">{{ $t('common.btn.new') }}</el-button>-->
                  <el-button
                    v-show="$checkPermission(['button_AEBooking_addAEBooking'])"
                    no="3"
                    type="primary"
                    @click="toCopy"
                  >{{ $t('SeaExport.Copy') }}</el-button>

                  <el-button
                    v-show="$checkPermission(['button_AEBooking_addAEBooking']) && showImportOrder"
                    no="copyFromJob"
                    type="primary"
                    @click="importOrder"
                  >{{ $t('SeaExport.ImportOrder') }}</el-button>

                  <el-button no="4" type="success" @click="onPrint">{{ $t('SeaExport.print') }}</el-button>

                  <el-button
                    v-show="btnInfo.visible.profitPrintable"
                    no="5"
                    type="primary"
                    @click="profitPrintHandler"
                  >{{ $t('SeaExport.PrintProfitAnalysis') }}</el-button>
                  <el-button
                    v-show="btnInfo.visible.btnPreSubmit"
                    no="6"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_PreSubmit"
                  >{{ $t('SeaExport.PreSubmission') }}</el-button>
                  <!--提交-->
                  <el-button
                    v-show="btnInfo.visible.btnSubmit"
                    no="7"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_Submit"
                  >{{ $t('SeaExport.Submission') }}</el-button>
                  <!--主管提交-->
                  <el-button
                    v-show="btnInfo.visible.btnManagerSubmit"
                    no="8"
                    type="primary"
                    class="can-operate"
                    :disabled="isCooperate"
                    @click="doSubmitPrint_ManagerSubmit"
                  >{{ $t('SeaExport.ManagerSubmission') }}</el-button>

                  <!--审核-->
                  <el-button
                    v-show="btnInfo.visible.btnManagerAuditSubmit"
                    no="9"
                    type="primary"
                    :disabled="isCooperate"
                    @click="doSubmitAudit_ManagerSubmit"
                  >{{ $t('SeaExport.Audit') }}</el-button>
                  <!--退回操作-->
                  <el-button
                    v-show="btnInfo.visible.printReturnOperate"
                    no="10"
                    type="primary"
                    :disabled="isCooperate"
                    @click="backReturn"
                  >{{ $t('SeaExport.ReturnAction') }}</el-button>
                  <!--撤回-->
                  <el-button
                    v-show="btnInfo.visible.cancelable"
                    no="11"
                    type="primary"
                    class="can-operate"
                    :disabled="isCooperate || controlledLocked"
                    @click="backReturn"
                  >{{ $t('SeaExport.PrintReturn') }}</el-button>
                  <el-button
                    v-show="$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                    no="returnReview"
                    type="primary"
                    @click="returnReview"
                  >{{ $t('CargoMsg.Cargo_ReturnPreApprovalRemoteBooking') }}</el-button>

                  <el-button
                    v-if="job.shutOut?btnInfo.privilege.button_AEBooking_cancelShutout:btnInfo.privilege.button_AEBooking_Shutout"
                    no="12"
                    type="primary"
                    :disabled="!(job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.SHUT_OUT) || isCooperate"
                    @click="toShutOut"
                  >{{ btnInfo.label.shutOutLabel }}</el-button>
                  <!--协作-->
                  <el-button v-show="showCooperateButton&&!isRegionalCommission" no="bntCooperation" type="primary" @click="cooperationHandler">{{ $t('CargoMsg.Cargo_Cooperation') }}</el-button>
                  <!--退回-->
                  <el-button v-show="showReturnButton" no="bntCooperationReturn" type="primary" @click="cooperationReturnHandler">{{ $t('CargoMsg.Cargo_CooperationReturn') }}</el-button>
                  <!--发送分公司-->
                  <el-button
                    v-show="showSendCompany"
                    no="13"
                    type="primary"
                    :class="btnInfo.label.SendToBranchCompany === $t('SeaExport.AssociationBusinessInformation') ? 'can-operate' : ''"
                    :disabled="!btnInfo.privilege.sendable && !btnInfo.visible.btSendBranch"
                    @click="sendBranchHandlerPre"
                  >{{ btnInfo.label.SendToBranchCompany }}</el-button>

                  <!--提交改单费用-->
                  <el-button
                    v-show="job.jobState === SystemConstants.VERIFIED && job.changeState === SystemConstants.VERIFIED && $checkPermission(['button_JobBooking_ChangeCommit']) && Number(config.get('IsCommittedAllowAddCost')) === 1"
                    no="14"
                    type="primary"
                    @click="changeCommit_clickHandler"
                  >{{ $t('SeaExport.ChangeCommit') }}</el-button>

                  <!--出口转进口-->
                  <template v-if="showAEToAI">
                    <el-dropdown
                      v-if="btnInfo.label.btnEntrustmentAI === $t('SeaExport.AssociationBusinessInformationSI') && job.relatedJob && !isRegionalCommission"
                      no="AssociationBusinessInformationSI"
                      class="el-dropdown-spacing can-operate"
                      split-button
                      type="primary"
                      @click="syncInfoHandle()"
                      @command="p=>{syncInfoCommand=p;syncInfoHandle()}"
                    >{{ syncInfoCommand }}
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="$t('SeaExport.AssociationBusinessInformationSI')">{{ $t('SeaExport.AssociationBusinessInformationSI') }}</el-dropdown-item>
                        <el-dropdown-item :command="$t('SeaExport.SynchronizationInformation')" :class="canOperateJob ? '' : 'ae-detail-cannot-operate-job'">{{ $t('SeaExport.SynchronizationInformation') }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button
                      v-else-if="job.masterFlag || !(job.operateType === AirExportConstants.CONSOLE.code)"
                      no="15"
                      type="primary"
                      :class="btnInfo.label.btnEntrustmentAI === $t('SeaExport.AssociationBusinessInformationSI') ? 'can-operate' : ''"
                      :disabled="!((btnInfo.privilege.consignationEnableAI && $store.getters.isGroupCompany))"
                      @click="entrustmentSIClickHandler"
                    >{{ btnInfo.label.btnEntrustmentAI }}</el-button>
                  </template>

                  <!-- 同步信息-交差委托-委托方同步至操作方【租户内】 -->
                  <el-button
                    v-show="crossDelegationSynchronizationField && (job.relatedJob || job.trustFromJob)"
                    no="16"
                    :disabled="job.jobState !== SystemConstants.STATE_OPERATING.code"
                    type="primary"
                    @click="syncRelatedJob"
                  >{{ $t('SeaExport.SynchronizationInformation') }}</el-button>
                  <el-dropdown
                    no="16"
                    class="el-dropdown-spacing can-operate"
                    split-button
                    type="primary"
                    @click="logHandle()"
                    @command="p=>{logCommand=p;logHandle()}"
                  >{{ $t('CargoMsg.Cargo_LogRecord') }}<el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="$t('CargoMsg.Cargo_BusinessStatusChangeLog')">{{ $t('CargoMsg.Cargo_BusinessStatusChangeLog') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.DataPushChangeLog')">{{ $t('SeaExport.DataPushChangeLog') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.OperationLog')">{{ $t('SeaExport.OperationLog') }}</el-dropdown-item>
                  </el-dropdown-menu>
                  </el-dropdown>
                  <!--锁定买价-->
                  <el-button
                    v-show="job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && !job.purchasePriceLock && $checkPermission(['button_AEBooking_PurchasePriceLock'])"
                    no="PurchasePriceLock"
                    type="primary"
                    @click="updatePriceLock_clickHandler(true,true)"
                  >{{ $t('CargoMsg.Cargo_lockLabel1') }}</el-button>
                  <!--锁定卖价-->
                  <el-button
                    v-show="job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && !job.sellingPriceLock && $checkPermission(['button_AEBooking_SellingPriceLock'])"
                    no="SellingPriceLock"
                    type="primary"
                    @click="updatePriceLock_clickHandler(false,true)"
                  >{{ $t('CargoMsg.Cargo_lockLabel2') }}</el-button>
                  <!--解锁买价-->
                  <el-button
                    v-show="job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && job.purchasePriceLock && $checkPermission(['button_AEBooking_PurchasePriceUnLock'])"
                    no="PurchasePriceUnLock"
                    type="primary"
                    @click="updatePriceLock_clickHandler(true,false)"
                  >{{ $t('CargoMsg.Cargo_lockLabel3') }}</el-button>
                  <!--解锁卖价-->
                  <el-button
                    v-show="job.jobState === SystemConstants.OPERATING && !masterFlag && action ==='look' && job.sellingPriceLock && $checkPermission(['button_AEBooking_SellingPriceUnLock'])"
                    no="SellingPriceUnLock"
                    type="primary"
                    @click="updatePriceLock_clickHandler(false,false)"
                  >{{ $t('CargoMsg.Cargo_lockLabel4') }}</el-button>
                </div>
                <div v-show="action==='edit'" class="btn-group-edit" style="border-left:none;padding-left:0">
                  <el-button no="17" type="success" :disabled="context.loading" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="18" type="success" @click="cancelEdit(()=>{againShow('look')})">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="19" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
                <div v-show="isNew" class="btn-group-new" style="border-left:none;padding-left:0">
                  <el-button no="20" type="success" :disabled="context.loading" @click="save">{{ $t('common.btn.save') }}</el-button>
                  <el-button no="21" type="success" @click="cancelEdit(goBack)">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button no="22" type="primary" @click="saveDefaultVal">{{ $t('SeaExport.SaveTheDefaultValues') }}</el-button>
                </div>
              </cargo-button-group-slider>
              <div v-show="action==='look'|| action==='edit'" style="padding-left: 6px; border-left: 2px solid #FFF;margin-left: 10px;display:flex;white-space:nowrap;">
                <!-- im入口 -->
                <CargoIm v-show="imCacheKey && action==='look'" ref="cargoIm" />
                <span no="SopState" style="font-size:14px;color:red">
                  {{ commonInfo.jobState }}
                  <!-- 「正操作」「预提交」「已提交」「已审核」业务状态存在费用时 进行退关操作后，需要显示为「XXX（有费用退关）」-->
                  <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && !commonInfo.jobChangeState" style="font-size:14px">({{ $t('Message.HasChargeToShutOut') }})</font>
                  <font v-if="(job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut && commonInfo.jobChangeState" style="font-size:14px">({{ $t('Message.HasChargeToShutOut') }}/{{ commonInfo.jobChangeState }})</font>
                  <font v-if="!((job.jobState === 0 || job.jobState === 1 || job.jobState === 2 || job.jobState === 11) && job.shutOut) && commonInfo.jobChangeState" style="font-size:14px">({{ commonInfo.jobChangeState }})</font>
                  <span v-if="job.payableChargeLockedStatus === 1" style="margin: 0px 0px 0px 0px;">{{ $t('CargoMsg.Cargo_PayableLockedStatusTag') }}<el-tooltip effect="dark" :content="payableChargeLockedTooltip" placement="bottom" :visible-arrow="false"><i class="el-icon-warning" style="cursor:pointer;" /></el-tooltip></span>
                </span>
                <el-tooltip effect="dark" :content="action==='edit' ? '' : $t('SeaExport.Tip1')" placement="bottom-start">
                  <template>
                    <span v-if="action==='edit'&&activeTabName==='tabCharges'" style="font-size:12px;padding: 7px 9px;color:unset;" v-html="commonInfo.chargeJobTitle" />
                    <el-button v-else no="23" type="text" style="font-size:12px;padding: 7px 9px;color:unset;" @dblclick.native="onBtnListDoubleClicked()" v-html="commonInfo.jobTitle" />
                  </template>
                </el-tooltip>
                <span style="font-size:12px;color:red">{{ commonInfo.jobLock }}</span>
                <span v-if="commonInfo.provisionLock && commonInfo.provisionLock.etdLocked" style="font-size:14px;color:red;margin-left:10px;">计提已校准</span>
                <el-tooltip v-if="job.zyCreditWarning" effect="dark" :content="job.zyCreditWarning" placement="bottom-start" :visible-arrow="false">
                  <div class="right-tip" style="cursor:pointer;font-size:12px;color:orange;width:350px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
                    <span>{{ job.zyCreditWarning }}</span>
                  </div>
                </el-tooltip>
              </div>
              <span v-show="isNew&&activeTabName==='tabCharges'" v-html="commonInfo.chargeJobTitle" />
            </div>
          </div>
          <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              :before-leave="(activeName,oldActiveName)=>{beforeLeaveTab(activeName,oldActiveName)}"
              style="width:100%"
              @tab-click="handleTabClick"
            >
              <!--出口操作-小票-->
              <el-tab-pane
                v-if="!masterFlag"
                :key="1"
                :lazy="true"
                name="basicTab"
                :label="$t('SeaExport.Basic')"
              >
                <tab-general-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="basicTab"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :cooperate-edit="cooperateEditOther"
                  view-source="AeBooking"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @tabNotCheckedCallBack="tabNotCheckedCallBack"
                  @generalMChargeWeight="generalMChargeWeightHandler"
                  @generalHChargeWeight="generalHChargeWeightHandler"
                  @removeJobFromMaster="removeJobFromMaster"
                  @detchJobFromMaster="detchJobFromMaster"
                  @changeOperateType="changeOperateType"
                  @syncDocSft="syncDocSft"
                  @updateJob="updateJob"
                />
                <basic-tab
                  v-else
                  ref="basicTab"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :cooperate-edit="cooperateEditOther"
                  view-source="AeBooking"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @tabNotCheckedCallBack="tabNotCheckedCallBack"
                  @generalMChargeWeight="generalMChargeWeightHandler"
                  @generalHChargeWeight="generalHChargeWeightHandler"
                  @removeJobFromMaster="removeJobFromMaster"
                  @detchJobFromMaster="detchJobFromMaster"
                  @changeOperateType="changeOperateType"
                  @syncDocSft="syncDocSft"
                  @updateJob="updateJob"
                />
              </el-tab-pane>
              <!--出口操作-主票-->
              <el-tab-pane
                v-if="masterFlag"
                :key="2"
                :lazy="true"
                name="masterBasicTab"
                :label="$t('SeaExport.Basic')"
              >
                <tab-master-UICustom
                  v-if="$store.state.uiCustom.enable && !isFba"
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :is-sea-export="true"
                  view-source="AeBooking"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @goBack="goBackForDeleteJob"
                  @generalMChargeWeight="generalMChargeWeightHandler"
                />
                <master-basic-tab
                  v-else
                  ref="masterBasicTab"
                  :context="context"
                  :action="action"
                  :is-fba="isFba"
                  :is-sea-export="true"
                  view-source="bookingWorkspace"
                  :cooperate-edit="cooperateEditOther"
                  :template-name="templateName"
                  :provision-lock="commonInfo.provisionLock"
                  @addLcl="addBatchLcl"
                  @selectJob="jobUuid=>{transferTargetRow('edit', jobUuid)}"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                  @containerLoadTypeEvent="containerLoadTypeEvent"
                  @goBack="goBackForDeleteJob"
                  @generalMChargeWeight="generalMChargeWeightHandler"
                />
              </el-tab-pane>
              <el-tab-pane key="tabAirVesselEq" :lazy="true" name="tabAirVesselEq" :label="$t('CargoMsg.Cargo_Booking')">
                <tab-vessel-eq-UICustom v-if="$store.state.uiCustom.enable && !isFba" ref="tabAirVesselEq" :context="context" :cooperate-edit="cooperateEditBooking" :action="action" :job="job" />
                <tab-air-vessel-eq v-else ref="tabAirVesselEq" :context="context" :cooperate-edit="cooperateEditBooking" :action="action" :job="job" />
              </el-tab-pane>
              <!-- 数据追踪 -->
              <el-tab-pane
                key="tabAirDataTracking"
                :lazy="true"
                name="tabAirDataTracking"
                :label="$t('SeaExport.AirDataTracking')"
              >
                <tab-air-data-tracking ref="tabAirDataTracking" :context="context" :job.sync="job" :action="action" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearance"
                :lazy="true"
                name="tabUsCustomsClearance"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance ref="tabUsCustomsClearance" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentAISynchronized" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="masterFlag && paramsOfTab.usCustomsClearance"
                key="tabUsCustomsClearanceMaster"
                :lazy="true"
                name="tabUsCustomsClearanceMaster"
                :label="$t('queryJob.UsCustomsClearance')"
              >
                <tab-us-customs-clearance-master ref="tabUsCustomsClearanceMaster" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentAISynchronized" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane
                v-if="(!isNew || action === 'copy') && (masterFlag || paramsOfTab.operateType === 2 || paramsOfTab.operateType === 3)"
                :key="6"
                :lazy="true"
                name="tabMAWB"
                label="MAWB"
              >
                <tab-mawb ref="tabMAWB" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @tabNotCheckedCallBack="tabNotCheckedCallBack" @resetTab="resetTab" />
              </el-tab-pane>
              <el-tab-pane
                v-if="(!isNew || action === 'copy') && !masterFlag && paramsOfTab.operateType !== 2"
                :key="7"
                :lazy="true"
                name="tabHAWB"
                label="HAWB"
              >
                <tab-hawb ref="tabHAWB" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @resetTab="resetTab" @syncData="syncData" />
              </el-tab-pane>
              <!-- 形式分单-->
              <el-tab-pane
                v-if="!isNew && paramsOfTab.virtualHBL"
                :key="8"
                :lazy="true"
                name="tabSubBill"
                :label="$t('SeaExport.FormalHbl')"
              >
                <tab-sub-bill ref="tabSubBill" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @resetTab="resetTab" @syncData="syncData" />
              </el-tab-pane>
              <!-- 装板信息 -->
              <el-tab-pane
                v-if="!isNew && !masterFlag && (paramsOfTab.operateType !== 0 || paramsOfTab.lclMasterUuid)"
                :key="26"
                :lazy="true"
                name="tabUnitLoadDevice"
                :label="$t('CargoMsg.Cargo_MountingInformation')"
              >
                <tab-unit-load-device ref="tabUnitLoadDevice" :context="context" :action="action" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <el-tab-pane
                v-if="!isNew && masterFlag"
                :key="26"
                :lazy="true"
                name="tabLclUnitLoadDevice"
                :label="$t('CargoMsg.Cargo_MountingInformation')"
              >
                <tab-lcl-unit-load-device
                  ref="tabLclUnitLoadDevice"
                  :context="context"
                  :action="action"
                  :cooperate-edit="cooperateEditOther"
                  @addSlavedJob="addSlavedJob"
                  @removeJobFromMaster="removeJobFromMaster"
                  @removeJob="removeJob"
                />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBAAeBooking_fbaSeaWarehouseTab'])" :key="32" :label="$t('AirExport.DomesticWarehouse')" :lazy="true" name="fbaWarehousingDetail">
                <!-- 国内仓 -->
                <fba-warehousing-detail ref="fbaWarehousingDetail" lob="FBA" :action="action" :cooperate-edit="cooperateEditOther" source="fbaAir" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBAAeBooking_fbaSeaoverSeaWarehouseTab'])" :key="33" :label="$t('AirExport.ForeignWarehouse')" :lazy="true" name="fbaOutWarehouse">
                <!-- 国外仓 -->
                <fba-out-warehouse ref="fbaOutWarehouse" :action="action" :context="context" :cooperate-edit="cooperateEditOther" source="fbaAir" />
              </el-tab-pane>
              <!-- 货物明细-->
              <el-tab-pane
                v-if="!isFba"
                :key="19"
                :lazy="true"
                name="tabTradeDetail"
                :label="$t('SeaExport.TradeDetail')"
              >
                <tab-trade-detail ref="tabTradeDetail" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && isFba && !masterFlag && $checkPermission(['tab_FBAAeBooking_fbaAirGoodsDetailTab'])" :key="31" :label="$t('SeaExport.TradeDetail')" :lazy="true" name="fbaGoodsDetail">
                <!-- fba货物明细 -->
                <tab-warehousing-detail ref="fbaGoodsDetail" :context="context" :action="action" source="fbaAir" :cooperate-edit="cooperateEditOther" @reload="refresh" />
              </el-tab-pane>
              <!--贸易-->
              <el-tab-pane
                v-if="paramsOfTab.itmService"
                :key="20"
                :lazy="true"
                name="tabTradeCommission"
                :label="$t('SeaExport.TradeCommission')"
              >
                <tab-trade-commission ref="tabTradeCommission" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @syncData="syncData" />
              </el-tab-pane>
              <!-- 费用-->
              <template v-if="privilege.charge.chargeView">
                <el-tab-pane
                  v-if="!chargePageSet.hideTabCharge"
                  :key="21"
                  :lazy="true"
                  name="tabCharges"
                  :label="$t('SeaExport.Charge')"
                >
                  <tab-charges ref="tabCharges" :context="context" :action="action" :location="location" view-source="AeBooking" :enable-ui-custom="true" :provision-lock="commonInfo.provisionLock" @printDataCallBack="tabChargesPrintDataCallBack" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="chargePageSet.arAloneShow && $checkPermission(['tab_Charge_chargeReceivable'])"
                  key="chargeArTab"
                  :lazy="true"
                  name="tabChargesAr"
                  :label="$t('queryJob.FeeReceivable')"
                >
                  <tab-charges ref="tabChargesAr" :context="context" :action="action" :location="location" view-source="AeBooking" tab-name="tabChargesAr" type="ar" :enable-ui-custom="true" @printDataCallBack="tabChargesPrintDataCallBack" />
                </el-tab-pane>
                <el-tab-pane
                  v-if="chargePageSet.apAloneShow && $checkPermission(['tab_Charge_chargePayable'])"
                  key="chargeApTab"
                  :lazy="true"
                  name="tabChargesAp"
                  :label="$t('queryJob.CostsPayable')"
                >
                  <tab-charges ref="tabChargesAp" :context="context" :action="action" :location="location" view-source="AeBooking" tab-name="tabChargesAp" type="ap" :enable-ui-custom="true" @printDataCallBack="tabChargesPrintDataCallBack" />
                </el-tab-pane>
              </template>
              <!-- 国内账单-->
              <el-tab-pane
                v-if="!isNew && privilege.chargeConfirm.chargeConfirmView"
                :key="22"
                :lazy="true"
                name="tabInternalBill"
                :label="$t('SeaExport.InternalBillInfo')"
              >
                <tab-internal-bill ref="tabInternalBill" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <!-- 国外账单-->
              <el-tab-pane
                v-if="!isNew && privilege.billTab.billTabView"
                :key="23"
                :lazy="true"
                name="tabOverseaBill"
                :label="$t('SeaExport.OverseaBillInfo')"
              >
                <tab-oversea-bill ref="tabOverseaBill" :context="context" :action="action" :location="location" view-source="AeBooking" />
              </el-tab-pane>
              <!-- 代收垫付-->
              <el-tab-pane
                v-if="!isNew && privilege.charge.advanceCharge"
                :key="24"
                :lazy="true"
                name="tabAdvanceCharge"
                :label="$t('SeaExport.AdvanceChargeInfo')"
              >
                <tab-advance-charge ref="tabAdvanceCharge" :context="context" :action="action" :location="location" />
              </el-tab-pane>
              <!-- 报关/续程-->
              <el-tab-pane
                v-if="!isNew"
                :key="18"
                :lazy="true"
                name="tabCustomsInfo"
                :label="$t('SeaExport.CustomsDeclarationOnward')"
              >
                <tab-customs-info ref="tabCustomsInfo" :context="context" :action="action" :cooperate-edit="cooperateEditCustoms" />
              </el-tab-pane>
              <!-- 保险 -->
              <el-tab-pane
                v-if="!isNew && ($store.state.uiCustom.enable && !isFba && masterFlag ? paramsOfTab.insure : true)"
                :lazy="true"
                name="tabInsure"
                :label="$t('SeaExport.InsureInfo')"
              >
                <tab-insure ref="tabInsure" :context="context" :action="action" />
              </el-tab-pane>
              <!--单证流转-->
              <el-tab-pane
                v-if="!isNew"
                :key="25"
                :lazy="true"
                name="tabFile"
                :label="$t('SeaExport.DocumentCirculation')"
              >
                <tab-file ref="tabFile" :context="context" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!-- 仓库内装 -->
              <el-tab-pane
                v-if="!masterFlag && !isNew"
                :key="15"
                :lazy="true"
                name="tabWarehouseTrucking"
                style="flex: 0"
                :label="$t('SeaExport.WarehouseLoading')"
              >
                <warehouse-new-page ref="tabWarehouseTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditWarehouse" />
              </el-tab-pane>
              <!--客户门点-->
              <el-tab-pane
                v-if="!masterFlag && !isNew && paramsOfTab.loadingTerm == 'DD'"
                :key="29"
                :lazy="true"
                name="tabTrucking"
                :label="$t('SeaExport.Trucking')"
              >
                <trucking-page ref="tabTrucking" :context="context" :action="action" :cooperate-edit="cooperateEditTrucking" />
              </el-tab-pane>
              <!-- 目的港派车tab -->
              <el-tab-pane
                v-if="paramsOfTab.dischargingPortDoor && privilege.aeBooking.aeDischargingTrukingPage"
                key="tabDischargingTrucking"
                :lazy="true"
                name="tabDischargingTrucking"
                :label="$t('SeaExport.DispatchVehiclesAtDestination')"
              >
                <tab-discharging-trucking ref="tabDischargingTrucking" :context="context" :action="action" :show-sync="btnInfo.btnEntrustmentAISynchronized" :cooperate-edit="cooperateEditOther" />
              </el-tab-pane>
              <!-- 货物信息-->
              <el-tab-pane
                v-if="!masterFlag && !isNew"
                :key="17"
                :lazy="true"
                name="tabWarehouse"
                :label="$t('SeaExport.CargoInfo')"
              >
                <tab-warehouse ref="tabWarehouse" :context="context" :action="action" :cooperate-edit="cooperateEditOther" @refreshTabs="refresh" />
              </el-tab-pane>
              <!--  业务状态-->
              <el-tab-pane
                v-if="!isNew && privilege.aeBooking.portalState"
                :key="27"
                :lazy="true"
                name="tabSopState"
                :label="$t('SeaExport.BusinessStatus')"
              >
                <tab-sop-state ref="tabSopState" :context="context" :action="action" :cooperate-edit="cooperateEditOther" :controlled-locked="controlledLocked" :sop-template-config="sopTemplateConfig" />
              </el-tab-pane>

              <!--文件历史-->
              <el-tab-pane
                v-if="!isNew"
                :key="28"
                :lazy="true"
                name="tabFileHistory"
                :label="$t('SeaExport.FileHistory')"
              >
                <tab-file-history ref="tabFileHistory" :context="context" :btn-info="btnInfo" :cooperate-edit="cooperateEditOther" :can-operate-job="canOperateJob" :controlled-locked="controlledLocked" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
    <drop-uploader v-if="job.jobState === SystemConstants.OPERATING && activeTabName !== 'tabTradeDetail'" :action="URL.common.uploadStorage" :upload-params="uploadParams" @upload-end="globalUploadEnd" />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      ref="templateSelectorDialog"
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 单条业务 配置规则验证弹窗-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
    />
    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      @callback="estimateValidationDialog.callback"
    />
    <!-- 数据推送变更记录弹窗 -->
    <el-dialog
      v-if="dataPushDialog.visible"
      v-el-drag-dialog
      no="24"
      :visible.sync="dataPushDialog.visible"
      :title="$t('SeaExport.DataPushChangeLog')"
      width="580px"
      :close-on-click-modal="false"
      class="app-main-inner"
      @close="dataPushDialog.visible=false"
    >
      <div
        class="app-main-inner-row"
        style="padding: 0;display: flex;flex-direction: column"
        :style="{width:'100%',height:'400px',overflow:'auto'}"
      >
        <div v-for="(title,index) in dataPushDialog.titles" :key="index">
          <div style="background:#EBECF5">
            <b>{{ title }}</b>
          </div>
          <div v-for="(item,index) in dataPushDialog.dataMap.get(title)" :key="index">
            <div>{{ item }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 业务状态变更记录弹窗 -->
    <business-status-log-dialog
      v-if="businessStatusDialog.visible"
      :visible.sync="businessStatusDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- EDI状态变更记录弹窗 -->
    <edi-status-log-dialog v-if="ediStatusLogDialog.visible" :visible.sync="ediStatusLogDialog.visible" :job-uuid="job.uuid || ''" />
    <!-- 订舱回执操作日志弹窗 -->
    <booking-space-log-dialog
      v-if="bookingSpaceLogDialog.visible"
      :visible.sync="bookingSpaceLogDialog.visible"
      :job-uuid="job.uuid || ''"
    />
    <!-- SOP操作状态弹窗 :visible.sync="sopStateDialog.visible"-->
    <sop-state-dialog :hide-window="isEditing" :visible.sync="sopStateDialog.visible" :is-need-refresh.sync:="sopStateDialog.isNeedRefresh" :default-is-expand="sopStateDialog.defaultIsExpand" :job="job" :is-need-expand.sync="sopStateDialog.isNeedExpand" @handleClose="sopStateDialogClose" />
    <!-- 发送分公司/tenant内部委托 -->
    <template v-if="sendBranchWindow.visible">
      <el-dialog
        v-if="sendBranchSelectObject === 2"
        v-el-drag-dialog
        no="25"
        :visible.sync="sendBranchWindow.visible"
        :title="$t('SeaExport.ConsignationSI')"
        width="550px"
        :close-on-click-modal="false"
      >
        <el-form label-width="40px" label-position="left">
          <el-form-item label-width="0">
            <span style="color: #000000;font-size: 14px;">{{ $t('queryJob.EntrustedRecipient') }}</span>
          </el-form-item>
          <el-form-item v-show="!enableEntrustmentAI" :label="$t('queryJob.route')">
            <cargo-user-select
              no="26"
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape:'airline'}"
              style="width: 200px"
              @change="p=>{sendBranchWindow.items[0].userId=p.value;userId_changeHandler(sendBranchWindow.items[0])}"
            />
          </el-form-item>
          <template v-if="enableEntrustmentAI">
            <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : $t('SeaExport.Operation')">
              <cargo-user-select
                :no="'27' + (index > 0 ? `-${index}` : '')"
                :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
                style="width: 200px"
                @change="p=>{item.userId=p.value;userIdAI_changeHandler(item)}"
              />
            </el-form-item>
          </template>
        </el-form>
        <el-form label-width="40px" :inline="true" label-position="left">
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ $store.getters.currentOffice.chineseName }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <div style="width: 200px;color: #000000;font-size: 14px;text-align: center;">{{ sendBranchWindow.title }}</div>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consignee" disabled style="width: 200px">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeTarget" style="width: 200px" @change="onConsigneeTargetChange">
              <el-option :label="$t('Message.Consignee')" value="consignee" />
              <el-option :label="$t('SeaExport.ConsignationCompany')" value="customer" />
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-select value="consigneeDetail" disabled style="width: 200px">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
            </el-select>
          </el-form-item>
          <el-form-item label-width="44px">
            <span slot="label" style="color: rgb(153, 153, 153);">———</span>
            <el-select v-model="sendBranchWindow.consigneeDetailTarget" style="width: 200px" @change="onConsigneeDetailTargetChange">
              <el-option :label="$t('SeaExport.ConsigneeDetail')" value="consigneeDetail" />
              <el-option :label="$t('SeaExport.ShipperDetail')" value="shipperDetail" />
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-top: 20px;">{{ $t('queryJob.NoteConsigneeCustomerExportImport') }}</div>
        <div slot="footer" style="display: flex;justify-content: space-between;">
          <el-checkbox v-model="sendBranchWindow.checkConsigneeDefault" style="color: #000000" @change="onCheckConsigneeDefaultChange">{{ $t('queryJob.SetAsDefaultExportInfo') }}</el-checkbox>
          <div>
            <el-button no="28" type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
            <el-button no="29" @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        v-else
        v-el-drag-dialog
        no="25"
        :visible.sync="sendBranchWindow.visible"
        :title="sendBranchWindow.title"
        width="360px"
        :close-on-click-modal="false"
      >
        <el-form label-width="85px" label-position="left">
          <el-form-item v-show="!enableEntrustmentAI" :label="$t('queryJob.route')">
            <cargo-user-select
              no="26"
              :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape:'airline'}"
              @change="p=>{sendBranchWindow.items[0].userId=p.value;userId_changeHandler(sendBranchWindow.items[0])}"
            />
          </el-form-item>
          <template v-if="enableEntrustmentAI">
            <el-form-item v-for="(item, index) in sendBranchWindow.items" :key="index" :label="item.selectObject === 0 ? $t('SeaExport.CustomerService') : $t('SeaExport.Operation')">
              <cargo-user-select
                :no="'27' + (index > 0 ? `-${index}` : '')"
                :method-params="{officeId: sendBranchWindow.office.officeId, category:'role', shape: item.selectObject === 0 ? 'csr' : 'op'}"
                @change="p=>{item.userId=p.value;userIdAI_changeHandler(item)}"
              />
            </el-form-item>
          </template>
          <el-form-item v-if="showdCheckSalesMapping" :label="$t('queryJob.SalesMapping')">
            <el-checkbox v-model="sendBranchWindow.checkSalesMapping" no="checkSalesMapping">{{ $t('queryJob.SalesCargoSalesMap') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" style="margin: 0 auto;width: fit-content;">
          <el-button no="28" type="primary" @click="enterSendHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="29" @click="sendBranchWindow.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </el-dialog>
    </template>
    <!--关联业务信息-->
    <ae-trust-from-window
      v-if="trustFromWindow.visible"
      ref="trustFromWindow"
      :visible.sync="trustFromWindow.visible"
      :trust-job="trustFromWindow.trustJob"
      :job="trustFromWindow.job"
      :context="context"
      :can-operate-job="canOperateJob"
      @refresh="applyCloseAndRefresh"
    />
    <!-- 退关弹窗 -->
    <el-dialog
      v-if="shutOutDialog.visible"
      v-el-drag-dialog
      no="30"
      :visible.sync="shutOutDialog.visible"
      :title="$t('Message.Warning')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;padding-left:30px">
        <span style="line-height: 40px;">{{ $t('Message.PleaseConfirmTheShutOut') }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip1 }}</span>
        <span style="line-height: 18px;">{{ shutOutDialog.shutOutTip2 }}</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="31" type="primary" @click="hasChargeShutoutHandler()">{{ $t('Message.HasChargeToShutOut') }}</el-button>
        <el-button
          no="32"
          :style="{ display: shutOutDialog.shutOutButtonShow2 }"
          type="primary"
          @click="noHasChargeShutoutHandler()"
        >{{ $t('Message.NoChargeToShutOut') }}</el-button>
        <el-button no="33" @click="shutOutDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 验证规则-保存业务节点弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      lob="AE"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />

    <!--关联进口业务信息-->
    <related-ai-from-window
      v-if="relatedAiFromWindow.visible"
      :visible.sync="relatedAiFromWindow.visible"
      :related-job="relatedAiFromWindow.relatedJob"
      :can-operate-job="canOperateJob"
    />
    <!--选择协作分公司-->
    <cooperation-branch-list
      v-if="cooperationBranchListDialog.visible"
      :visible.sync="cooperationBranchListDialog.visible"
      :job-uuid="cooperationBranchListDialog.jobUuid"
      :job="cooperationBranchListDialog.job"
      :order-center-branch="cooperationBranchListDialog.orderCenterBranch"
      @refresh="(cooperatebranch)=>{updateJobCooperate(cooperatebranch);this.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)}"
      @cancel="()=>cooperationBranchListDialog.visible=false"
    />
    <!-- 业务申请审批流 -->
    <job-apply-dialog
      v-if="jobApplyDialog.visible"
      :visible.sync="jobApplyDialog.visible"
      :title="$t('CargoMsg.Cargo_SubmitJobChargeForApproval')"
      type="apply"
      :doc-id="job.uuid"
      :document-config-id="documentConfigId"
      @close="jobApplyDialog.visible=false"
      @closeAndRefresh="applyCloseAndRefresh"
    />
    <!-- 变更日志记录 弹窗 -->
    <data-update-log-dialog :hide-window="isEditing" :visible.sync="dataUpdateLogDialog.visible" :is-need-refresh.sync:="dataUpdateLogDialog.isNeedRefresh" :default-is-expand="dataUpdateLogDialog.defaultIsExpand" :job="job" :is-need-expand.sync="dataUpdateLogDialog.isNeedExpand" @handleClose="dataUpdateLogDialogClose" />
    <!--  导入订单数据弹框  -->
    <import-order-dialog
      v-show="importOrderDialog.visible"
      ref="importOrderDialog"
      :visible.sync="importOrderDialog.visible"
      :lob="importOrderDialog.job.lob || 'AE'"
      :job="importOrderDialog.job"
      @confirmCallBack="data=>{ importOrderConfirmCallBack(data) }"
    />
    <job-return-review-dialog
      v-show="returnReviewDialog.visible"
      :visible.sync="returnReviewDialog.visible"
      lob="AE"
      :selected-jobs="returnReviewDialog.selectedJobs"
      srouce="detail"
      @confirm="refresh"
    />
  </div>
</template>

<script>
import { BookingWorkspaceContext } from './bookingWorkspaceContext'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { BookingWorkspacePM } from './bookingWorkspacePM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import URL from '@/api/urlTranslator'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import businessStatusLogDialog from '@/views/cargo/v0/Clearing/components/financeManage/businessStatusLogDialog'
import ediStatusLogDialog from '@/components/Cargo/Job/ediStatusLogDialog'
import bookingSpaceLogDialog from '@/components/Cargo/Job/bookingSpaceLogDialog'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import { TabError } from '@/utils/class/TabError'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { getUserDefaultDepartment } from '@/api/user'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { Company } from '@/class/model/mdm/Company'
import { Office } from '@/class/model/sys/Office'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { EntityDefaultValueUtil } from '@/class/cargo/model/utils/EntityDefaultValueUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { PrintUtils } from '@/utils/PrintUtils'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { ensureExecuteSuccess, deepCopy, catchErrorTip } from '@/utils/commonUtil'
import { getDocumentType } from '@/api/documentType'
import { checkJobProvisionFlag, normalizeProvisionLock } from '@/api/provision/provisionData'
import {
  canBatchShutout, shutOut, getChargeIsInvoice, commit, saveJobInfo, calculateProfit,
  printProfit, crossTenantJob, isContractExpiredForbidCreateJob, checkingConsignationJob
} from '@/api/seaExport/seaExportJob'
import { queryCompany, mainTainCurrentTenantCompanies, getCompanyByTenantIdAndBranchIdAndScac } from '@/api/company'
import { updateChangeState } from '@/api/clearing/financeManage'
import { queryLatestState, isRejectedBySendJobNo, isCrossed } from '@/api/booking/crossTenantHistory'
import { isHavePorts } from '@/api/seaport'
import { isHavePacking } from '@/api/basicData/packing'
import { queryTemplateByNameAndType } from '@/api/sysManage/baseConfig/template'
import { sortByMultiField } from '@/utils'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import basicTab from './tabs/tabGeneral'
import tabGeneralUICustom from './tabs/tabGeneralUICustom'
import tabMawb from './tabs/tabMAWB'
import tabHawb from './tabs/tabHAWB'
import tabSubBill from './tabs/tabSubBill'
import tabWarehouse from './tabs/tabWarehouse'// 空出货物信息
import tabCustomsInfo from './tabs/tabCustomsInfo' // 报关续程
import tabTradeDetail from './tabs/tabTradeDetail' // 贸易明细
import tabTradeCommission from './tabs/tabTradeCommission' // 贸易
import tabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges' // 费用
import tabInternalBill from '@/components/Cargo/Job/booking/tabs/tabInternalBill' // 国内账单
import tabOverseaBill from '@/components/Cargo/Job/booking/tabs/tabOverseaBill' // 国外账单
import tabAdvanceCharge from '@/components/Cargo/Job/booking/tabs/tabAdvanceCharge' // 代收垫付
import tabFile from '@/components/Cargo/Job/booking/tabs/tabFile' // 单证流转
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState' // 业务状态
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory' // 文件历史
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import {
  saveAeBookingSpace,
  saveEntrustedByBranch,
  saveCopyJob,
  submitState,
  createImportByExportJob,
  getRelatedAiJob,
  syncRelatedJobFunc,
  syncRelatedJob,
  getTrustFromJob, updatePriceLockFunc, importOrderJob
} from '@/api/AirExport/airExportJob'
import { sendJobSiRui, getDepartmentIdOfRole, backReturn, sendJobCBMS } from '@/api/booking/job'
import { canCreateByCreditInfoDetail } from '@/api/partner/creditInfo'
import masterBasicTab from './tabs/tabMaster'
import tabMasterUICustom from './tabs/tabMasterUICustom'
import StrUtils from '@/utils/StrUtils'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import lodash from 'lodash'
import { sendSapMessageByJob } from '@/api/clearing/charge'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import truckingPage from '@/components/Cargo/Warehouse/truckingPage'
import tabDischargingTrucking from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabDischargingTrucking'
import warehouseNewPage from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import { sendHecMessageByJob, backHecMessageByJob } from '@/api/clearing/charge'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow'
import tabUsCustomsClearance from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearance'
import tabUsCustomsClearanceMaster from '@/components/Cargo/Job/booking/tabs/tabUsCustomsClearanceMaster'
import { SopUtil } from '@/class/cargo/model/utils/SopUtil'
import tabWarehousingDetail from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehousingDetail'
import FbaWarehousingDetail from '@/views/cargo/v0/FBA/Warehousing/fbaWarehousingDetail'
import FbaOutWarehouse from '@/views/cargo/v0/FBA/OverseaWarehousing/fbaOutWarehouse'
import relatedAiFromWindow from './relatedAiFromWindow'
import cooperationBranchList from '@/components/Cargo/Job/cooperationBranchList'
import { updateState } from '@/api/booking/jobCooperate'
import CargoIm from '@/components/Cargo/Common/CargoIm'
import { DocumentManage, stringToNumArray } from '@/utils/commonUtil'
import TabUnitLoadDevice from '@/components/Cargo/Job/booking/tabs/tabUnitLoadDevice'
import TabLclUnitLoadDevice from '@/components/Cargo/Job/booking/tabs/tabLclUnitLoadDevice'
import AeTrustFromWindow from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/aeTrustFromWindow'
import { getOfficeByUuid } from '@/api/office'
import JobApplyDialog from '@/components/Cargo/Common/Wrokflow/jobApplyDialog'
import { Job_CHARGE } from '@/class/cargo/model/parameters/WorkflowConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import TabAirVesselEq from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEq'
import tabVesselEqUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabVesselEqUICustom'
import TabAirDataTracking from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/TabDataTracking'
import TabInsure from '@/components/Cargo/Job/booking/tabs/tabInsure'
import { ACTION_ADD, AE, SALES_CHANNEL_OCR_RECOGNITION } from '@/class/cargo/model/parameters/SystemConstants'
import { LOG_AE_AIR_BOOKING } from '@/class/cargo/model/parameters/SystemConstants'
import DataUpdateLogDialog from '@/components/Cargo/Job/dataUpdateLogDialog'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { fbaGetRelatedJob, fbaSaveCloneJob } from '@/api/Fba/fbaJob'
import BookingWorkspaceMixin from '@/mixin/BookingWorkspaceMixin'
import { cache, cacheName } from '@/utils/cacheManager'
import ImportOrderDialog from '@/components/Cargo/Job/importOrderDialog'
import { DD_STUFFY_TYPE } from '@/class/cargo/model/parameters/AirExportConstants'
import jobReturnReviewDialog from '@/components/Cargo/Job/jobReturnReviewDialog.vue'
import { getSopTemplateConfig } from '@/api/sysManage/baseConfig/businessManage'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'AeBookingWorkspace',
  components: {
    jobReturnReviewDialog,
    TabAirDataTracking,
    TabAirVesselEq,
    tabVesselEqUICustom,
    AeTrustFromWindow,
    TabLclUnitLoadDevice,
    TabUnitLoadDevice,
    FbaOutWarehouse,
    FbaWarehousingDetail,
    DropUploader,
    masterBasicTab, tabMasterUICustom, basicTab, tabGeneralUICustom, cargoAdvanceSelect, cargoUserSelect, cargoLeftRightResize, cargoTemplateSelectorDialog, businessStatusLogDialog,
    ediStatusLogDialog, bookingSpaceLogDialog, tabMawb, tabHawb, tabSubBill, tabWarehouse, tabCustomsInfo, tabTradeDetail,
    tabTradeCommission, tabCharges, tabInternalBill, tabOverseaBill, tabAdvanceCharge, tabFile, tabSopState, tabFileHistory,
    CheckingWindow, EstimateValidationDialog, BatchCheckingWindow, sopStateDialog, CargoButtonGroupSlider, truckingPage, tabDischargingTrucking, warehouseNewPage, checkingSaveJobWindow,
    tabUsCustomsClearance, tabUsCustomsClearanceMaster, tabWarehousingDetail, relatedAiFromWindow, cooperationBranchList, CargoIm, ImportOrderDialog,
    JobApplyDialog, TabInsure, DataUpdateLogDialog
  },
  mixins: [BookingWorkspaceMixin],
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    isFba: {
      type: Boolean,
      default: false
    },
    view: {
      type: String,
      default: ''
    }
  },
  data() {
    const currentUserInfo = getUserInfo()
    const leftGridColumnType = window.localStorage.getItem(`AE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`) || 'jobNo'
    return {
      JobUtils,
      imCacheKey: '',
      optName: '', // 操作名称
      leftGridColumnType,
      visible: false,
      URL,
      selectTypeNames: TYPE_NAMES,
      context: new BookingWorkspaceContext(this.parentContext),
      pm: new BookingWorkspacePM(this),
      SystemConstants,
      AirExportConstants,
      copyJobNum: 0,
      isUppercaseByConfig: true, // CARGO-49117 是否大写
      privilege: {
        aeBooking: {
          portalState: this.$checkPermission(['button_AEBooking_portalState']),
          aeDischargingTrukingPage: this.$checkPermission(['tab_AEBooking_AEDischargingTrukingPage'])
        },
        salesQueryModule: {
          vesselEqTab: this.$checkPermission(['tab_SalesQueryModule_VesselEqTab'])
        },
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView']),
          advanceCharge: this.$checkPermission(['tab_Charge_advanceCharge'])
        },
        chargeConfirm: {
          chargeConfirmView: this.$checkPermission(['tab_ChargeConfirm_chargeConfirmView'])
        },
        billTab: {
          billTabView: this.$checkPermission(['tab_billTab_billTabView'])
        },
        fileHistory: {
          fileHistoryView: this.$checkPermission(['tab_FileHistory_fileHistoryView'])
        }
      },
      btnInfo: {
        label: {
          shutOutLabel: this.$t('SeaExport.ShutOut'),
          SendToBranchCompany: this.$t('SeaExport.SendToBranchCompany'),
          btnEntrustment: this.$t('SeaExport.Consignation'), // 内部委托按钮
          btnEntrustmentAI: this.$t('SeaExport.ConsignationSI') // 出口转进口按钮
        },
        btnEntrustmentAISynchronized: false, // 出口转进口（已同步过）
        visible: {
          btSendBranch: false, // 允许发送公司
          sendBackBookingButton: false, // 发送订舱数据
          profitPrintable: false, // 利润分析打印
          cancelable: false, // 取消
          printFclProfit: false, // 整箱利润打印
          printLclProfit: false, // 拼箱利润打印
          printReturn: false, // 撤回
          printReturnOperate: false, // 退回
          btnSubmit: false, // 提交
          btnManagerSubmit: false, // 主管提交
          btnPreSubmit: false, // 预提交
          btnManagerAuditSubmit: false // 审核
        },
        privilege: {
          btnEntrustment: null, // 委托按钮是否禁用
          btnShutout: false, // 退关按钮是否可用
          sendable: false, // 允许发送公司
          consignationCrossEnable: false, // 跨分公司委托是否可用
          crossMoreSign: false,
          consignationEnableAI: false, // 出口转进口按钮是否可用
          button_AEBooking_cancelShutout: this.$checkPermission(['button_AEBooking_cancelShutout']),
          button_AEBooking_Shutout: this.$checkPermission(['button_AEBooking_Shutout']),
          button_JobBooking_Submit: this.$checkPermission(['button_JobBooking_Submit']),
          button_JobBooking_PreSubmit: this.$checkPermission(['button_JobBooking_PreSubmit']),
          button_JobBooking_ManagerSubmit: this.$checkPermission(['button_JobBooking_ManagerSubmit']),
          button_JobBooking_ManagerAuditSubmit: this.$checkPermission(['button_JobBooking_ManagerAuditSubmit']),
          button_JobBooking_PrintProfit: this.$checkPermission(['button_JobBooking_PrintProfit']),
          button_SEBooking_cancelProfit: this.$checkPermission(['button_AEBooking_cancelProfit']),
          button_JobBooking_Retract: this.$checkPermission(['button_JobBooking_Retract']),
          button_JobBooking_ReturnToOperater: this.$checkPermission(['button_JobBooking_ReturnToOperater'])
        }
      },
      commonInfo: {
        allowShutoutable: false, // 航班大于今天的业务是否允许退关
        operateNameCode: -1, // 操作code
        jobState: '',
        jobChangeState: '',
        jobTitle: '',
        invoiceMode: '',
        jobLock: '',
        provisionPublished: false, // 计提已发布状态
        provisionLock: { etdLocked: false, feeLocked: false },
        isPreCommit: false, // 预提交
        isPrintCommit: false, // 打印利润分析表是否提交业务
        allSubmitFcl: false, // 主票提交时是否提交全部拼票业务
        reqInputCharge: false, // 是否必录费用
        isBookingFeeMandatoryAppliedGlobally: false, // 订舱费用必填是否全模块应用
        checkEstimate: false, // 预估是否验证过
        isCopySellingCharge: false, // 复制应付费用
        needConfirmDuplicateWarehouseNo: false, // 是否要验证进仓编号重复
        synchronousShipperCodeAndConsigneeCodeAndNotifyCode: false, // 提单收发通代码是否同步至基本页签收发通代码
        overwriteJobRefNoBySEconvertSI: false, // 出口转进口客户参考号生成规则
        isPrint: true,
        isPrintOpr: false, // 是否打印操作（由于打印和提交中最后调用的有相同的方法，因此用改参数区分开来）
        openSapConfig: 0, // 验证sap费用结算公司
        openHecConfig: false, // 合创推送
        printEvent: null,
        showMessage: true,
        chargeSyncNeedConfirm: false, // 出口进口费用同步，是否需要确认。
        chargeJobTitle: '',
        copyFromJob: false
      },
      action: '',
      editEventFlag: false, // 编辑事件标识
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressContextMenu: false,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: leftGridColumnType === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MAWB',
          colId: leftGridColumnType,
          field: leftGridColumnType,
          width: 160,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true
          },
          suppressMenu: true
        },
        columnDefs: [],
        context: {
          componentParent: this
        },
        getContextMenuItems: () => {
          const self = this
          const menu = [
            'copy',
            {
              name: self.$t('SeaExport.BusinessNo'),
              action: function() {
                const currentUserInfo = getUserInfo()
                self.leftGridColumnType = 'jobNo'
                window.localStorage.setItem(`AE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'jobNo')
              }
            }, {
              name: 'MAWB',
              action: function() {
                self.leftGridColumnType = 'mbl'
                const currentUserInfo = getUserInfo()
                window.localStorage.setItem(`AE_LEFT_GRID_TYPE_${currentUserInfo.tenantId}_${currentUserInfo.userId}`, 'mbl')
              }
            }
          ]
          return menu
        },
        onRowClicked: async event => {
          let job = event.data
          // 若选中提单拆并单,则需要找到其父级job
          if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
            for (const item of this.rowData) {
              if (item.uuid === job.jobUuid) {
                job = item
                break
              }
            }
          }
          this.action = job && Number(cache.config.get('JobDirectEditingStatus')) === 1 && job.jobState === 0 && !JobUtils.isBlockJob(job) && (await SecurityUtil.canEdit(new AirExportJob(job))) ? 'edit' : 'look'
          this.onRowClicked(event)
        },
        onCellClicked: async event => {
          this.getImGroupFunc(event)
        }
      },
      rowData: [],
      gridApi: null,
      currentRow: {},
      basicInfo: {
        gridOptions: {
          rowSelection: 'single',
          columnDefs: [
            {
              headerName: this.$t('SeaExport.BasicInfo'),
              field: 'basic',
              width: 160,
              suppressMenu: true,
              tooltipValueGetter: params => params.value
            }
          ],
          suppressContextMenu: false,
          getRowStyle: function(params) {
            if (params.data.isTitle) {
              return {}
            } else {
              return { 'color': '#666666' }
            }
          },
          context: {
            componentParent: this
          }
        },
        rowData: []
      },
      paramsOfTab: {},
      pendTabSet: new Set(),
      isRefresh: false,
      activeTabName: '',
      partner: {}, // 发送分公司-合作伙伴
      relatedJobUUID: '', // 跨tenant委托，接收方的jobUuid
      template: {}, // 跨tenant委托后调用模板，上传到云存储
      templateSelectorDialog: {
        visible: false,
        ctx: new AirExportJob(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'AE',
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      checkingWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        callBack2: null
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        tatolProfit: 0,
        callback: () => {}
      },
      submitDialog: {
        visible: false
      },
      syncInfoCommand: this.$t('SeaExport.AssociationBusinessInformationSI'),
      logCommand: this.$t('AirExport.LogRecords'),
      dataPushDialog: {
        visible: false,
        titles: [],
        dataMap: new Map()
      },
      businessStatusDialog: {
        visible: false
      },
      ediStatusLogDialog: {
        visible: false
      },
      bookingSpaceLogDialog: {
        visible: false
      },
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      sendBranchSelectObject: 0,
      sendBranchWindow: {
        visible: false,
        office: {},
        title: this.$t('queryJob.route'),
        items: [{
          selectObject: 0,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        }],
        consigneeTarget: '',
        consigneeDetailTarget: '',
        checkConsigneeDefault: false, // 将本次内容设置为默认转出口信息
        checkSalesMapping: false // 委托业务的销售映射到操作业务的揽货销售
      },
      trustFromWindow: {
        visible: false,
        job: null, // 当前业务
        trustJob: null // 关联业务job
      },
      saveJobNos: [], // 保存后的jobNo
      removedJobNos: [], // 被移除的jobNo
      isOtherEdit: false, // 拆分主票，复制业务，都属于新增的数据，uuid为空，但是大部分字段已经有值，不需要走初始化数据操作
      tabChargesPrintData: null, // tabCharges printData回调数据
      shutOutDialog: {
        visible: false,
        shutOutTip1: '',
        shutOutTip2: '',
        shutOutButtonShow2: '',
        jobKeys: '',
        hasCharge: false
      },
      btnGroupLook: null,
      btnGroupEdit: null,
      btnGroupNew: null,
      checkingSaveJobWindow: {
        visible: false,
        checkNode: 0,
        callBack: null,
        rowData: {}
      },
      enableEntrustmentAI: false, // 是否空出委托转海进
      showAEToAI: false, // CARGO-22531，空运出口转进口
      crossDelegationSynchronizationField: false, // CARGO-30023 空运交叉委托增加基本页签数据
      relatedAiFromWindow: { // 关联进口业务信息
        visible: false,
        relatedJob: null // 关联业务job
      },
      cooperationBranchListDialog: { // 协作分公司
        visible: false,
        jobUuid: '',
        job: null,
        orderCenterBranch: false
      },
      documentManage: new DocumentManage(),
      basicInfoVisible: false,
      jobApplyDialog: {
        visible: false
      },
      documentConfigId: Job_CHARGE.code,
      dataUpdateLogDialog: {
        visible: false,
        isNeedRefresh: false,
        job: {},
        defaultIsExpand: false,
        isNeedExpand: false
      },
      importOrderDialog: {
        visible: false,
        job: {}
      },
      returnReviewDialog: {
        visible: false,
        selectedJobs: []
      },
      enableCommission: false,
      toExoSystemJYD: false,
      toExoSystemDLWL: false,
      toExoSystemZY: false,
      sendBranchSelectObjectOrigin: '0', // 发送分公司选项配置原始值
      loading: null,
      sopTemplateConfig: {}, // SOP模板配置
      templateName: '',
      chargePageSet: { hideTabCharge: false, arAloneShow: false, apAloneShow: false } // 费用页签设置
    }
  },
  computed: {
    user() {
      return this.context.user
    },
    office() {
      return this.context.office
    },
    config() {
      return this.context.config
    },
    isNew() {
      return this.action === 'add' || this.action === 'split' || this.action === 'copy'
    },
    isEditing() {
      return this.action !== 'look'
    },
    masterFlag() {
      return this.paramsOfTab.masterFlag
    },
    isLclMaster() {
      return !!this.paramsOfTab.lclMasterUuid
    },
    isVerify() {
      // 预审
      return false
    },
    job() {
      return this.currentRow
    },
    payableChargeLockedTooltip() {
      const details = []
      const person = ColumnUtils.getPayableChargeLockedPerson(this.job)
      const lockedAt = this.job.payableChargeLockedDate ? DateUtils.formatStandardDateTime(this.job.payableChargeLockedDate) : ''
      if (person) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockPerson')}：${person}`)
      }
      if (lockedAt) {
        details.push(`${this.$t('CargoMsg.Cargo_PayableFeeLockTime')}：${lockedAt}`)
      }
      return details.join('\n')
    },
    uploadParams() {
      const { job, user } = this
      return {
        jobNo: job.jobNo,
        mbl: job.mbl,
        uuid: job.uuid,
        createdBy: user.userId,
        createChineseName: user.chineseName,
        createEnglishName: user.englishName,
        documentType: 'other',
        documentName: 'other',
        isShared: false,
        op: false,
        sales: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return this.config ? Number(this.config.get('useOrderCenterMode')) === 1 : false
    },
    useOrderCenterBranch() { // 是否开启接单分公司
      return this.config ? Number(this.config.get('orderCenterBranch')) === 1 : false
    },
    orderCenterBranch() { // 是否接单分公司
      return this.cooperateStatus === -1
    },
    useCooperate() { // 是否开启协作功能【1开启协作隐藏发送分公司，0不开启协作显示分公司】
      return this.config ? Number(this.config.get('useCooperate')) === 1 : false
    },
    showCooperateButton() { // 协作按钮显示【协作和发送分公司同时显示时则判断useCooperate】
      const showCooperate = this.useOrderCenterMode && !this.masterFlag && (!this.orderCenterBranch || (this.orderCenterBranch && this.useOrderCenterBranch))
      return showCooperate ? this.useCooperate : false
    },
    showReturnButton() { // 退回按钮显示
      const showReturn = this.useOrderCenterMode && !this.masterFlag && !this.orderCenterBranch
      return showReturn ? this.useCooperate : false
    },
    showSendCompany() { // 发送分公司按钮显示
      return !this.showCooperateButton
    },
    cooperateBranchId() { // 协作分公司
      return this.$store.getters.currentOfficeId
    },
    cooperateStatus() {
      let cooperateStatus = this.paramsOfTab.cooperateStatus || -1
      if (this.paramsOfTab.cooperateCooperateStatus) {
        cooperateStatus = this.paramsOfTab.cooperateCooperateStatus
      }
      return cooperateStatus
    },
    cooperateBusinessTypeCode() {
      let cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessTypeCode || ''
      if (!cooperateBusinessTypeCode && this.paramsOfTab.cooperateBusinessType) {
        cooperateBusinessTypeCode = this.paramsOfTab.cooperateBusinessType
      }
      return cooperateBusinessTypeCode
    },
    cooperateEditCustoms() { // 报关
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Customs')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditTrucking() { // 陆运
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Trucking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditBooking() { // 订舱
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Booking')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditWarehouse() { // 仓储
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      const index = cooperateBusinessTypeCode.indexOf('Warehouse')
      return this.orderCenterBranch ? index === -1 : index !== -1
    },
    cooperateEditOther() { // 其他
      if (this.job && this.job.businessLock) {
        return false
      }
      if (!this.useOrderCenterMode || this.isNew) return true
      const cooperateBusinessTypeCode = this.cooperateBusinessTypeCode
      if (!cooperateBusinessTypeCode) return true
      if (this.orderCenterBranch) return true
      return false
    },
    isCooperate() { // 是否协作业务
      if (this.useOrderCenterMode && !this.orderCenterBranch && this.paramsOfTab.cooperateUuid) {
        return true
      }
      return false
    },
    showBasicInfoForCharge() { // 显示基本信息
      return (this.isEditing && this.activeTabName === 'tabCharges' && this.basicInfoVisible)
    },
    location() {
      if (!this.isFba) {
        return LOG_AE_AIR_BOOKING.code
      }
      return ''
    },
    hqDisabledOperate() {
      return this.$store.getters.currentOfficeId === 1 && this.hqViewAllDetail
    },
    canOperateJob() {
      if (this.hqViewAllDetail) {
        if (this.$store.getters.currentOfficeId === 1) {
          return false
        }
        if (this.currentRow &&
          this.currentRow.opOffice !== this.$store.getters.currentOfficeId &&
          this.currentRow.salesOffice !== this.$store.getters.currentOfficeId &&
          !this.mactchCooperateBranch(this.currentRow.cooperatebranch, this.$store.getters.currentOffice) &&
          !this.enableCommission
        ) {
          return false
        }
      }
      if (this.hierarchyViewDetail && this.currentRow) {
        return this.matchOwnerBranch(this.currentRow)
      }
      return true
    },
    showdCheckSalesMapping() {
      return this.toExoSystemJYD && !this.enableEntrustmentAI && Number(this.sendBranchSelectObjectOrigin) === 3 && !this.job.fba
    },
    showImportOrder() {
      return this.commonInfo.copyFromJob && this.job.jobState === SystemConstants.OPERATING &&
        this.job.opOffice === this.$store.getters.currentOfficeId && !this.job.masterFlag && !this.job.lclMasterUuid
    },
    controlledLocked() {
      return this.toExoSystemDLWL && this.job.exportControlledLocked
    },
    showReturnReview() { // 是否显示退回按钮
      return this.job.jobState === SystemConstants.STATE_OPERATING.code && !this.job.masterFlag &&
        !this.job.lclMasterUuid && (this.job.preverifyState === SystemConstants.VERIFYING_AUDITED.code ||
          this.job.preverifyState === SystemConstants.VERIFYING_REVIEW_THROUGH.code)
    },
    trackingTemplateUuid() {
      return this.currentRow.trackingTemplateUuid
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.btnGroupLook = this.$el.getElementsByClassName('btn-group-look')[0]
          this.btnGroupEdit = this.$el.getElementsByClassName('btn-group-edit')[0]
          this.btnGroupNew = this.$el.getElementsByClassName('btn-group-new')[0]
        })
      }
    },
    leftGridColumnType(newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      console.log(newVal, oldVal)
      this.gridOptions.api.setAutoGroupColumnDef({
        headerName: newVal === 'jobNo' ? this.$t('SeaExport.BusinessNo') : 'MAWB',
        colId: newVal,
        field: newVal,
        width: 160,
        tooltip: (params) => {
          return newVal === 'jobNo' ? params.data.jobNo : params.data.mbl
        },
        cellRendererParams: {
          suppressCount: true,
          suppressDoubleClickExpand: true
        },
        suppressMenu: true
      })
    },
    action(newVal) {
      this.$nextTick(() => {
        this.$refs.cargoButtonGroupSlider.resizeHandler()
      })
    },
    editEventFlag(newVal) {
      if (newVal) {
        this.editEventFlag = false
        return catchErrorTip(() => {
          return this.editHandler('edit')
        })
      }
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        if (this.$store.state.uiCustom.enable) {
          this.loadPageSet()
        }
        if (this.$route.name !== 'AeBooking' || this.view !== 'detail') {
          return
        }
        await cache.load(cacheName.CONFIG)
        this.enableCommission = cache.config.get('enableCommission') === '1'
        if (this.hqViewAllList && !this.hqViewAllDetail) {
          if (this.$store.getters.currentOfficeId === 1) {
            this.$confirm(this.$t('queryJob.SwitchHQNotView'), this.$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt'), {
              confirmButtonText: this.$t('queryJob.JumpListPage'),
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.goBack()
            }).catch(() => {})
          }
        }
      }
    },
    trackingTemplateUuid: {
      immediate: true,
      async handler(newVal) {
        this.templateName = await SopUtil.getTemplateName(newVal)
      }
    }
  },
  async created() {
    await this.context.prepareData()
    this.loadConfigData()
    getSopTemplateConfig({ lob: 'AE' }).then(res => {
      this.sopTemplateConfig = res.data
    })
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBasicInfo', function() {
      context.showBasicInfo()
    })
    if (this.$store.state.uiCustom.enable) {
      this.loadPageSet()
    }
  },
  mounted() {
    this.sendBranchWindow.checkConsigneeDefault = LocalStorageUtilsNew.getConfiguration('AE_checkConsigneeDefault') || false
    if (this.sendBranchWindow.checkConsigneeDefault) {
      this.sendBranchWindow.consigneeTarget = LocalStorageUtilsNew.getConfiguration('AE_consigneeTargett', 'string') || 'consignee'
      this.sendBranchWindow.consigneeDetailTarget = LocalStorageUtilsNew.getConfiguration('AE_consigneeDetailTarget', 'string') || 'consigneeDetail'
    }
  },
  updated() {
    if (!this.$refs['tabs']) {
      return
    }
    const panes = this.$refs['tabs'].panes
    const tabNameSet = new Set()
    for (const item of panes) {
      tabNameSet.add(item.name)
    }
    // 将失效的tab名称从pendTabSet中移除
    for (const item of [...this.pendTabSet]) {
      if (!tabNameSet.has(item)) {
        this.pendTabSet.delete(item)
      }
    }
  },
  methods: {
    loadPageSet() {
      this.chargePageSet = UICustomUtil.getChargePageSet(UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE)
    },
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.imCacheKey = sessionStorage.getItem('imCacheKey')
      if (!this.visible) {
        this.visible = true
      }
      if (action === 'edit') {
        selectedRow.version = 0
        selectedRow.charges = ''
        selectedRow.isCompleteRow = false
      }
      this.currentRow = selectedRow
      this.paramsOfTab = this.currentRow
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      if (!this.activeTabName) {
        this.paramsOfTab.masterFlag = this.currentRow.masterFlag = selectedRow.masterFlag
        this.$nextTick(() => {
          this.activeTabName = this.getDefaultActiveName()
        })
      }
      this.isOtherEdit = action === 'split' || action === 'copy'
      this.action = action
      JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_AE, action === 'look', selectedRow.jobNo || '')
      if (selectedRow.uuid) {
        this.rowData = [...rowData]
      } else {
        if (!selectedRow.lclNumber && !this.isOtherEdit) {
          this.context.loading = true
          await Promise.all([this.context.getDefaultAirExportJob(), this.context.getCurrentOfficeOpDepartment(this.user.userId, this.$store.getters.currentOfficeId)])
          this.context.loading = false
          // 新建job 默认值&赋值默认值
          await this.buildNewRow(selectedRow)
        }
        const localCurrency = RateUtil.localCurrencyByOffice()
        if (!selectedRow.sellingCurrency) {
          selectedRow.sellingCurrency = localCurrency
        }
        if (!selectedRow.buyingCurrency) {
          selectedRow.buyingCurrency = localCurrency
        }
        // CARGO-53866 东丽 新增复制业务 销售默认带入当前登录人
        await JobUtils.loadingDlwlSales(selectedRow, this)
        if (!Object.prototype.hasOwnProperty.call(selectedRow, 'path')) selectedRow.path = ''
        this.rowData = [...rowData, selectedRow]
      }
      this.context.loading = true
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        this.context.loading = false
        this.setGridSelect(selectedRow)
        await this.onRowClicked({ data: selectedRow })
        if (action === 'look') {
          this.getImGroupFunc({ data: selectedRow })
        }
      })

      if (action === 'look') {
        const cfg = LocalStorageUtils.getConfiguration('AESopStatusPopupVisible')
        this.sopStateDialog.visible = !!cfg
        const logDialogVisible = LocalStorageUtilsNew.getConfiguration('AEDataUpdateLogDialogVisible')
        this.dataUpdateLogDialog.visible = !!logDialogVisible
      }
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    // sop 双击事件
    onBtnListDoubleClicked() {
      LocalStorageUtils.setConfiguration('AESopStatusPopupVisible', true)
      this.sopStateDialog.visible = true
      this.sopStateDialog.defaultIsExpand = true
      this.sopStateDialog.isNeedExpand = true
    },
    // sop 关闭处理
    sopStateDialogClose() {
      this.sopStateDialog.defaultIsExpand = true
      LocalStorageUtils.setConfiguration('AESopStatusPopupVisible', false)
    },
    // log 关闭处理
    dataUpdateLogDialogClose() {
      this.dataUpdateLogDialog.defaultIsExpand = true
      LocalStorageUtilsNew.setConfiguration('AEDataUpdateLogDialogVisible', false)
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 加载配置项
    loadConfigData() {
      this.btnInfo.visible.sendBackBookingButton = Number(this.config.get('sendBackBookingButton')) === 1
      this.commonInfo.allowShutoutable = Number(this.config.get('EtdGreaterThanTodayShutout')) === 1

      this.commonInfo.openSapConfig = Number(this.config.get('openSapConfig')) === 1
      this.commonInfo.openHecConfig = Number(this.config.get('openHecConfig')) === 1
      this.commonInfo.reqInputCharge = Number(this.config.get('saveCharge')) === 1
      this.commonInfo.isBookingFeeMandatoryAppliedGlobally = Number(this.config.get('isBookingFeeMandatoryAppliedGlobally')) === 1
      this.commonInfo.allSubmitFcl = Number(this.config.get('AllSubmitFcl')) === 1
      this.commonInfo.isPrintCommit = Number(this.config.get('isPrintCommit')) === 1
      this.commonInfo.isCopySellingCharge = Number(this.config.get('isCopySellingCharge')) === 1
      this.commonInfo.needConfirmDuplicateWarehouseNo = Number(this.config.get('needConfirmeDuplicateWarehouseNo')) === 1
      this.commonInfo.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      this.commonInfo.overwriteJobRefNoBySEconvertSI = Number(this.config.get('OverwriteJobRefNoBySEconvertSI')) === 1
      this.sendBranchSelectObjectOrigin = this.config.get('SendBranchSelectObject')
      this.readSendBranchSelectObject()
      this.showAEToAI = Number(this.config.get('consignationImportByAE')) === 1
      // CARGO-43586 0:不开启，1：开启同步信息功能（仅支持显示和使用同步信息按钮），2：开启同步文件历史功能（支持显示和使用同步文件历史、取消同步 按钮），3：同时开启（现有开启逻辑）
      this.crossDelegationSynchronizationField = Number(this.config.get('crossDelegationSynchronizationField')) === 1 || Number(this.config.get('crossDelegationSynchronizationField')) === 3 // 名航模式
      this.commonInfo.chargeSyncNeedConfirm = Number(this.config.get('ChargeSyncNeedConfirm')) === 1
      this.enableCommission = Number(this.config.get('enableCommission')) === 1
      this.toExoSystemJYD = this.config.get('ToExoSystem') === 'JYD'
      this.toExoSystemDLWL = this.config.get('ToExoSystem') === 'DLWL'
      this.toExoSystemZY = this.config.get('ToExoSystem') === 'zy'
      this.commonInfo.copyFromJob = Number(this.config.get('CopyFromJob')) === 1
      this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    },
    readSendBranchSelectObject() {
      this.sendBranchWindow.items = []
      let arr = stringToNumArray(this.config.get('SendBranchSelectObject'))
      if (arr.includes(2)) {
        this.sendBranchSelectObject = 2
        arr = [0, 1]
      } else {
        this.sendBranchSelectObject = arr[0] || 0
      }
      for (const selectObject of arr) {
        this.sendBranchWindow.items.push({
          selectObject,
          userId: 0,
          departmentId: 0,
          departmentOfficeId: 0
        })
      }
    },
    // 新增时 填充默认值
    async buildNewRow(row) {
      const rowBackup = lodash.cloneDeep(row)
      const isNew = !Object.keys(row).length
      // 填充默认值
      new AirExportJob(row).fillDefaultValue()
      // CARGO-46980 空运订舱，取消新增业务自动带出ETD
      // const today = new Date()
      // row.etd = DateUtils.customFormat(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1, today.getHours(), today.getMinutes()), 'YYYY-MM-DD HH:mm')
      row.lob = this.lob
      const localCurrency = RateUtil.localCurrencyByOffice()
      row.currency = localCurrency
      row.cargoType = 'GC'
      row.paymentTermMBL = 'PP'
      row.bookingTerm = BookingTerm.SB_BOOKING_TYPE.code
      row.cargoSource = CargoSource.NC_CARGO_SOURCE.code
      row.landTransportation = false
      row.taxNature = 0
      row.fba = this.isFba // 是否fba业务
      const office = this.$store.getters.currentOffice
      if (office) {
        row.opOffice = office.officeId
        row.loadingPortCode = office.airport
      }
      await getDepartmentIdOfRole({ 'shape': 'op', 'branchId': this.$store.getters.currentOfficeId }).then(res => {
        const opDepartmentId = res.data
        if (opDepartmentId && opDepartmentId > 0) {
          row.op = this.user.userId
          row.opOffice = office.officeId
          if (this.user.defaultDepId > 0 && this.user.defaultOfficeId === office.officeId) {
            row.opDepartment = this.user.defaultDepId
          } else {
            row.opDepartment = opDepartmentId
          }
        }
      })
      if (row.opOffice === 0) {
        row.opOffice = office.officeId
      }
      const aEDefaultDeliveryAgent = this.config.get('AEDefaultDeliveryAgent')
      if (aEDefaultDeliveryAgent) {
        row.deliveryAgent = aEDefaultDeliveryAgent
      } else {
        row.deliveryAgent = 0
      }
      if (row && !row.masterFlag) { // 小票
        row.masterFlag = false
        row.mblOnly = false
        let operate = 0
        const aEDefaultJobOperate = LocalStorageUtils.getConfiguration('AEDefaultJobOperate')
        if (aEDefaultJobOperate) {
          operate = Number(aEDefaultJobOperate)
        }
        row.mblOnly = (operate === AirExportConstants.DIRECT.code)
        row.operateType = operate
        row.copyOnly = false
      }
      row.path = ''
      // 贸易方式(老的cargo是写在LocalCacheComboBox下拉框组件里面，默认选中一般贸易)
      const tradeTerms = await getSpecificBasicData(basicCacheKeys.basic_data_TradeTerm)
      if (tradeTerms && tradeTerms.length > 0) {
        for (const tradeTerm of tradeTerms) {
          if (tradeTerm.name === '一般贸易') {
            row.tradeTerm = tradeTerm.code
          }
        }
      }
      Object.assign(row, this.context.defaultAirExportJob)
      if (!row.destinationPortCode) {
        row.destinationPortCode = row.dischargingPortCode
      }
      if (!isNew && !row.masterFlag) {
        Object.assign(row, rowBackup)
      }
      if (row && row.masterFlag) { // 主票固定默认值，一定要写在默认值defaultAirExportJob后面，否则会被覆盖
        row.masterFlag = true
        row.mblOnly = true
        row.operateType = parseInt(AirExportConstants.CONSOLE.code)
      }
      if (!row.lob) {
        row.lob = AE.code
      }
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        if (item.data.jobUuid === row.uuid || !item.data.uuid) {
          this.gridApi.setFocusedCell(item.rowIndex, this.gridApi.columnController.getAllDisplayedColumns()[0])
          break
        }
      }
    },
    // 行点击
    async onRowClicked(event) {
      this.context.loading = true
      sessionStorage.setItem('unread', false)
      if (!event.data) {
        this.context.loading = false
        return
      }
      let job = event.data
      // 若选中提单拆并单,则需要找到其父级job
      if (job.dataType && Number(job.dataType) !== 1 && Number(job.dataType) !== 2 && job.jobUuid) {
        for (const item of this.rowData) {
          if (item.uuid === job.jobUuid) {
            job = item
            break
          }
        }
        this.setGridSelect(job)
      }
      let loadCooperate = false
      // 加载job详细信息
      const jobModel = new AirExportJob(job)
      console.log('jobModel========', jobModel)
      if (job.uuid && !job.differenceJobFields) {
        this.context.loading = true
        await jobModel.loadJobRelated({
          job: true,
          lclSlaves: job.masterFlag,
          charges: true,
          warehouseIn: job.masterFlag,
          warehouseInfo: true,
          trucking: true,
          dischargingTrucking: true,
          lclMaster: !job.masterFlag,
          airCargoDoc: true,
          containerUsages: true,
          containers: true,
          fbaJob: job.fba, // fba业务就加载
          orderCenterMode: this.useOrderCenterMode,
          cooperateBranchId: this.cooperateBranchId,
          unitLoadDevices: true,
          unitLoadDeviceUsages: true,
          airUld: true
        })
        loadCooperate = true
        this.context.loading = false
        if (!job.path) {
          this.setBasicData(job)
          this.gridApi.refreshCells({ force: true })
        }
        // 检查主票下的小票，如果主票有修改，同步将小票放在修改列表中
        if (job.lclSlaves && job.lclSlaves.length > 0) {
          const index = this.saveJobNos.findIndex(p => p.uuid === job.uuid)
          if (index >= 0) {
            for (const slave of job.lclSlaves) {
              const row = this.rowData.find(p => p.uuid === slave.uuid)
              if (row) {
                for (const key in slave) {
                  if (typeof row[key] === 'object' || key === 'version') {
                    continue
                  }
                  row[key] = slave[key]
                }
                this.saveJobNos.push(row)
              }
            }
          }
        }
      } else {
        jobModel.lclSlaves = jobModel.lclSlaves || []
        jobModel.charges = jobModel.charges || []
        jobModel.warehouseIn = jobModel.warehouseIn || []
        jobModel.warehouseInfo = jobModel.warehouseInfo || []
        jobModel.trucking = jobModel.trucking || []
        jobModel.dischargingTrucking = jobModel.dischargingTrucking || []
        jobModel.airCargoDoc = jobModel.airCargoDoc || []
        jobModel.containerUsages = jobModel.containerUsages || []
        jobModel.containers = jobModel.containers || []
      }
      jobModel.usCustomsClearanceList = ''
      // 需重新构造对象，以便新增加的属性可以被vue监听到
      const newData = { ...job }
      /* 替换旧数据 */
      const index = this.rowData.findIndex(p => p.uuid === job.uuid)
      const node = this.gridApi.rowModel.rowsToDisplay.find(p => p.data.uuid === job.uuid)
      if (index >= 0 && node) {
        this.rowData[index] = newData
        node.data = newData
        job = newData
      }
      // 协作分公司信息
      if (this.useOrderCenterMode) {
        if (loadCooperate && job.cooperate && job.cooperate.uuid) {
          console.log('job.cooperate===', job.cooperate)
          // 记录原值
          job.opOffice_original = job.opOffice // 分公司
          job.op_original = job.op // 操作
          job.csr_original = job.csr // 客服
          job.overseaOp_original = job.overseaOp // 海外操作
          job.dc_original = job.dc // 单证
          job.planner_original = job.planner // 航线负责人
          job.opDepartment_original = job.opDepartment // 操作部门
          //
          job.opOffice = job.cooperate.branchId // 分公司
          job.op = job.cooperate.opId // 操作
          job.csr = job.cooperate.csrId // 客服
          job.overseaOp = job.cooperate.overseaOp // 海外操作
          job.dc = job.cooperate.dcId // 单证
          job.planner = job.cooperate.planner // 航线负责人
          job.opDepartment = job.cooperate.opDepartment // 操作部门
          JobUtils.convertJobFromCooperateInfo(job, job.cooperate)
          //
          job.cooperateUuid = job.cooperate.uuid
          job.cooperateCooperateStatus = job.cooperate.cooperateStatus
          job.cooperateBusinessType = job.cooperate.businessType
        }
      }
      if (this.toExoSystemZY) {
        // 中文品名
        job.cargoChineseName_original = job.cargoChineseName
        // 英文品名
        job.cargoEnglishName_original = job.cargoEnglishName
      }
      this.currentRow = job
      this.initInfo()
      this.resetParamsOfTab()
      this.pendTabSet.clear()
      this.context.modifiedData = {}
      this.basicInfoVisible = false
      if (!event.skipTabHandle) {
        this.$nextTick(() => {
          if (this.isNew) {
            this.activeTabName = this.getDefaultActiveName()
          } else {
            const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
            if (activePanes && activePanes.length === 0) {
              this.activeTabName = this.getDefaultActiveName()
            }
          }
          this.handleTabClick()
        })
      }
      if (this.$refs.tabAirVesselEq) {
        this.$refs.tabAirVesselEq.initData()
      }
    },
    resetParamsOfTab() {
      if (this.action === 'edit') {
        this.paramsOfTab = deepCopy(this.currentRow)
      } else {
        this.paramsOfTab = this.currentRow
      }
    },
    beforeLeaveTab(activeName, oldActiveName) {
      // 小票到主票 || 主票到小票 切换 不执行 endTabHandler
      if ((activeName === 'basicTab' && oldActiveName === 'masterBasicTab') || (activeName === 'masterBasicTab' && oldActiveName === 'basicTab')) {
        return
      }
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // tab页签结束后的处理
    async endTabHandler(tabName) {
      const tab = this.$refs[tabName]
      if (!tab) {
        return
      }
      if (tab.endTabHandler && typeof tab.endTabHandler === 'function') {
        const result = tab.endTabHandler()
        if (result instanceof Promise) {
          await result
        }
      }
    },
    // tab页签切换
    handleTabClick() {
      this.context.loading = true
      this.$nextTick(() => {
        if (this.activeTabName === 'tabCharges') {
          this.showBasicInfoWindow()
        }
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.paramsOfTab, isRefresh)
        this.context.loading = false
      })
    },
    // 整拼类型切换
    containerLoadTypeEvent(data) {
      if (this.masterFlag) {
        this.activeTabName = 'masterBasicTab'
      } else {
        this.activeTabName = 'basicTab'
      }
      // 清空pendTabSet.size 用于刷新
      this.pendTabSet = new Set()
      this.handleTabClick()
    },
    // 基本页签内，复选框控制部分页签显示隐藏的回调，控制this.pendTabSet集合元素
    tabNotCheckedCallBack(tabName) {
      this.pendTabSet.delete(tabName)
    },
    // 编辑
    async editHandler(action) {
      if (this.currentRow.jobState !== 0) {
        this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited'))
        return
      }
      if (!await SecurityUtil.canEdit(new AirExportJob(this.currentRow))) {
        this.$message.warning(this.$t('Message.NoPermissionToEditTheJob'))
        return
      }
      this.$refs.cargoLeftRightResize.hideLeft()
      this.btnGroupLook.style.display = 'none'
      this.btnGroupEdit.style.display = ''
      this.$refs.cargoButtonGroupSlider.resizeHandler()
      // 延迟执行，避免阻塞页面渲染
      setTimeout(() => {
        this.againShow(action)
      }, 5)
    },
    // 合并数据
    againShow(action, row) {
      this.action = action
      // 海进新增 add 时  需要弹出框 选择类型
      if (this.action === 'add') {
        this.$emit('add')
        return
      }
      const selectedRow = this.isNew ? row || {} : this.currentRow
      if (this.action !== 'edit' && selectedRow.differenceJobFields) {
        selectedRow.differenceJobFields = null
        selectedRow.differenceMawbFields = null
        selectedRow.differenceHawbFields = null
        // 重新加载
        selectedRow.airCargoDoc = ''
        selectedRow.charges = ''
      }
      this.onShow(action, this.rowData, selectedRow)
    },
    // 保存空运业务【保存业务相关数据】
    async save() {
      // 如果没有正确填写多程信息，则不让保存
      if (this.$refs.tabAirVesselEq && !this.$refs.tabAirVesselEq.airlineVerification()) {
        return
      }
      const loading = getLoading('app-main-content')
      try {
        if (this.activeTabName) {
          await this.endTabHandler(this.activeTabName)
        }
        const body = {}
        try {
          const pendTabSet = [...this.pendTabSet, 'other']
          for (const item of pendTabSet) {
            let tabData = null
            if (item !== 'other') {
              // 各页签的保存数据
              const getSubmitData = this.$refs[item].getSubmitData
              if (getSubmitData && typeof getSubmitData === 'function') {
                /* 获取各页签需要保存的数据 */
                const result = await this.$refs[item].getSubmitData()
                if (result instanceof Promise) {
                  tabData = await result
                } else {
                  tabData = result
                }
              }
            } else {
              // 被联动修改了的数据
              tabData = this.context.modifiedData
            }
            if (!tabData) continue
            // 将不同页签相同key的集合进行数据合并
            for (const key in tabData) {
              const tabValue = tabData[key]
              if (!tabValue) continue // 判断当前页签所传的数据是否有效，无效则不需要合并
              const bodyValue = body[key]
              if (!bodyValue || !Object.prototype.hasOwnProperty.call(body, key)) continue // 判断body中是否存在该key，不存在或者无数据则由下面统一合并
              // 将数组进行合并
              if (Array.isArray(tabValue)) {
                if (Array.isArray(bodyValue)) { // 这里面会将 uuid 相同的费用进行过滤，页签上的优先于 级联改动的数据
                  const bodyMap = new Map()
                  if (bodyValue && bodyValue.length > 0) {
                    for (const bodyKey of bodyValue) {
                      if (!bodyKey) continue
                      if (Object.prototype.hasOwnProperty.call(bodyKey, 'uuid') && bodyKey.uuid) bodyMap.set(bodyKey.uuid, bodyKey)
                    }
                  }
                  if (tabValue && tabValue.length > 0) {
                    for (const tabKey of tabValue) {
                      if (!tabKey || bodyValue.includes(tabKey)) continue
                      if (Object.prototype.hasOwnProperty.call(tabKey, 'uuid') && tabKey.uuid && bodyMap.has(tabKey.uuid)) continue
                      bodyValue.push(tabKey)
                    }
                  }
                } else {
                  tabValue.push(bodyValue)
                  body[key] = tabValue
                }
                delete tabData[key]
              }
            }
            Object.assign(body, tabData)
          }
          // 还原接单分公司
          if (this.useOrderCenterMode) {
            if (body.job && body.job.cooperateUuid) {
              body.job = { ...body.job }
              body.job.opOffice = body.job.opOffice_original || body.job.opOffice // 分公司
              body.job.op = body.job.op_original || body.job.op // 操作
              body.job.csr = body.job.csr_original || body.job.csr // 客服
              body.job.overseaOp = body.job.overseaOp_original || body.job.overseaOp // 海外操作
              body.job.dc = body.job.dc_original || body.job.dc // 单证
              body.job.planner = body.job.planner_original || body.job.planner // 航线负责人
              body.job.opDepartment = body.job.opDepartment_original || body.job.opDepartment // 操作部门
              JobUtils.restoreJobFromCooperateInfo(body.job)
            }
          }
          // 清空子表数据【原本是在各页签里面的，现在移到公共的地方来】
          if (Reflect.has(body, 'job') && body.job) {
            if (body.job === this.paramsOfTab) {
              body.job = { ...body.job }
            }
            for (const key in body.job) {
              // 这里必须要删除，不能将其置为空或者undefined，否则复制或者拆分主票没法赋值
              if (typeof body.job[key] === 'object') delete body.job[key]

              // 保存时需要将sop显示列排除
              if (key.indexOf('_sop_') !== -1 && key.startsWith('_sop_')) delete body.job[key]
            }
          }
          // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
          this.doNotClickTabData(body)

          // 主票 新增/加入小票 使用
          if (this.currentRow.lclNumber) {
            const job = this.currentRow
            if (job.warehouseInfo) {
              Object.assign(body, { warehouseInfo: job.warehouseInfo })
            }
            if (job.trucking) {
              Object.assign(body, { truckingInfo: job.trucking })
            }
            if (job.airCargoDoc) {
              Object.assign(body, { airCargoDoc: job.airCargoDoc })
            }
          }
          this.cleanCircleObject(body)
          JobUtils.handleChargeForSave(body)
        } catch (err) {
          if (err instanceof TabError) {
            this.activeTabName = err.tabName
            if (err.message) {
              this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
            }
            return
          }
          throw err
        }
        // 在保存前进行校验
        if (!(await this.pm.checkBeforeSave(body.job))) {
          return
        }
        const job = new AirExportJob(this.currentRow)
        if (!job.uuid) {
          // 新增业务时，需要判断是否可以新增该业务 CARGO-9472 超信控的合作伙伴不能新增业务
          let createByCreditInfo = true
          const params = JobUtils.getCreditCheckJob(job)
          await canCreateByCreditInfoDetail(params).then(async res => {
            if (res.data > 0) {
              createByCreditInfo = false
              const msg = {
                dangerouslyUseHTMLString: true,
                message: await JobUtils.checkDateAndAmountExceeded(res.data),
                type: 'warning',
                duration: 5000
              }
              this.$message.warning(msg)
              if (!job.masterFlag) {
                if (job.cargoSource === 'NC') {
                  job.designationAgent = 0
                } else {
                  job.customerId = 0
                }
              } else {
                job.designationAgent = 0
              }
            }
          })
          if (!createByCreditInfo) {
            return
          }
        }
        // 获取复制份数
        if (Reflect.has(body, 'job') && Reflect.has(body.job, 'copyNum') && Number(body.job.copyNum) > 1) {
          this.copyJobNum = Number(body.job.copyNum)
        }
        if (this.action !== 'copy') {
          if (!job.masterFlag) {
            job.mblOnly = job.operateType === AirExportConstants.DIRECT.code
          } else { // 主票都是直单
            job.mblOnly = true
          }
          job.copySCNotifyToDoc(await job.getCargoDoc(CargoDocConsts.MAWB, true))
          if (!job.masterFlag) {
            job.copySCNotifyToDoc(await job.getCargoDoc(CargoDocConsts.HAWB, true))
          }
        }
        job.skipBillsForNextTransaction = true
        job.skipAgentSharedChargesForNextTransaction = true
        job.copyOnly = false

        // 复制时校验费用名称是否被禁用
        if (this.action === 'copy') {
          const flag = await JobUtils.checkChargeItemDisabled(this, body.charges)
          if (!flag) {
            return
          }
        }
        // CARGO-54098 个性需求评估 增加SOP特殊限制
        if (this.toExoSystemDLWL && !await JobUtils.checkExportControlledProduct(body.job, this)) {
          return
        }

        // CARGO-53261 14615中邮，敏感词管理校验需要双重提醒
        if (this.toExoSystemZY && !await JobUtils.checkZySensitiveWord(body.job, this)) {
          return
        }

        // 后端触发SOP使用
        if (!this.isNew) body.jobUuid = this.job.uuid

        // 获取业务对应的sop模板，若不一致，则提醒是否更换，若一致不处理，若新增，则
        await SopUtil.checkSopTemplate(body.job, this, null, null, this.sopTemplateConfig)

        // 若为自揽货 清空指定货代理取值
        if (body.job && body.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
          body.job.designationAgent = 0
        }

        // CARGO-16870 验证规则节点增加“业务保存”
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        // CARGO-48635 OCR识别 创建业务时，本地服务选择“门点提货”，则创建门点信息
        if (body.job && !body.job.uuid && this.action === ACTION_ADD.code && body.job.salesChannel === SALES_CHANNEL_OCR_RECOGNITION.code) {
          if (body.job.loadingTerm === DD_STUFFY_TYPE.code) {
            body.truckingInfo = this.currentRow.trucking
          }
        }
        if (useCheckRule && body && body.hasOwnProperty('job') && body.job) {
          const hasCheckRuleForSaveJob = await JobUtils.hasCheckRuleCondition(useCheckRule, CheckRuleConstants.NODE_SAVE_BUSINESS.code, this.$store.getters.currentOfficeId)
          if (hasCheckRuleForSaveJob) {
            const result = await JobUtils.checkBySaveJobNode({ ...body, charges: this.paramsOfTab.charges }, this.job.lob, CheckRuleConstants.NODE_SAVE_BUSINESS.code)
            if (result.needShowDialog) {
              loading.close()
              const callBack = async() => { await this.continueSaving(body, loading, true) }
              this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BUSINESS.code
              this.checkingSaveJobWindow.rowData = result.rowData
              this.checkingSaveJobWindow.callBack = callBack
              this.checkingSaveJobWindow.visible = true
            } else {
              await this.continueSaving(body, loading, false)
            }
          } else {
            await this.continueSaving(body, loading, false)
          }
        } else {
          await this.continueSaving(body, loading, false)
        }
      } finally {
        loading.close()
      }
    },
    saveResultHandler(job) {
      sendJobSiRui({ jobUuid: this.currentRow.uuid }).then(res => {
        const message = res.data
        if (message) {
          this.$message.warning(this.$t('queryJob.SiruiPleaseContactTheTroubleshooting') + message)
        }
      })
      // remarkOptLogHandler(job as Job);
      // //同步portal信息
      // PortalManage.getInstance().synPortalShipmentOrderInfo(job);
    },

    refreshLeftTree() {
      // 保存/提交操作 的是 小票或者主票 因同步 主票件重尺，小票etd 等 刷新左侧列表避免未重新加载
      if (this.currentRow.masterFlag) {
        for (const job of this.rowData) {
          if (job.lclMasterUuid === this.currentRow.uuid) {
            job.isCompleteRow = false
            job.version = 0 // 标识为脏数据，需要重新载入
            // 重置子表数据
            for (const key in job) {
              if (typeof job[key] === 'object') {
                job[key] = ''
              }
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
      if (!StrUtils.isEmpty(this.currentRow.lclMasterUuid)) {
        const masterJob = this.rowData.find(item => item.uuid === this.currentRow.lclMasterUuid)
        if (masterJob) {
          masterJob.isCompleteRow = false
          masterJob.version = 0 // 标识为脏数据，需要重新载入
          // 重置子表数据
          for (const key in masterJob) {
            if (typeof masterJob[key] === 'object') {
              masterJob[key] = ''
            }
          }
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 复制、拆分主票保存前处理【未点击页签的数据也需要保存】
    doNotClickTabData(body) {
      const isCopy = this.action === 'copy'
      const isSplit = this.action === 'split'
      const job = this.currentRow
      if (!body || !job || (!isCopy && !isSplit)) return
      // 复制独有
      if (isCopy) {
        if (!Object.prototype.hasOwnProperty.call(body, 'airCargoDoc') && job.airCargoDoc && job.airCargoDoc.length > 0) {
          Object.assign(body, { airCargoDoc: job.airCargoDoc })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'warehouseInfo') && job.warehouseInfo && job.warehouseInfo.length > 0) {
          Object.assign(body, { warehouseInfo: job.warehouseInfo })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'trucking') && job.trucking && job.trucking.length > 0) {
          Object.assign(body, { truckingInfo: job.trucking })
        }
        if (!Object.prototype.hasOwnProperty.call(body, 'charges') && job.charges && job.charges.length > 0) {
          Object.assign(body, { charges: job.charges })
        }
      }
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      const job = obj.job || null
      for (const key in obj) {
        // 主票装箱信息循环引用特殊处理
        if (job && job.masterFlag && key === 'unitLoadDevices' && obj.unitLoadDevices && obj.unitLoadDevices.length > 0) {
          for (const container of obj.unitLoadDevices) {
            const unitLoadDeviceUsages = container.unitLoadDeviceUsage
            if (!unitLoadDeviceUsages || unitLoadDeviceUsages.length <= 0) break
            for (const containerUsage of unitLoadDeviceUsages) {
              if (containerUsage.hasOwnProperty('unitLoadDevice')) delete containerUsage.unitLoadDevice
            }
          }
          continue
        }
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    // 保存剩下的复制业务【后台复制并保存】
    async saveCopyJobHandle(jobUuid, copyNum, masterFlag) {
      //
      const item = {}
      item.jobUuid = jobUuid
      item.branchId = this.$store.getters.currentOfficeId
      // 复制哪些页签的数据
      const lob = this.currentRow.lob
      if (masterFlag) {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER')
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob + '_MASTER')
      } else {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + lob)
      }
      item.copyNum = copyNum
      item.masterFlag = masterFlag
      item.all = true
      item.copyOnly = true // 是否是复制业务，新增业务日志时使用
      item.location = this.location
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 给job设置基本信息
    setBasicData(jobData) {
      jobData.jobUuid = jobData.uuid
      jobData.parentUuid = jobData.uuid
      jobData.path = jobData.uuid
      jobData.dataType = 2 // 小票
    },
    // 保存剩下的新增小票业务【后台复制并保存】
    async saveLclJob(jobUuid, copyNum) {
      const item = {
        jobUuid,
        branchId: this.$store.getters.currentOfficeId,
        copyNum,
        all: true,
        copyOnly: false, // 是否是复制业务，新增业务日志时使用
        location: this.location
      }
      await saveCopyJob(item).then(res => {
        const newJobList = res.data
        if (newJobList && newJobList.length > 0) {
          for (const copyJob of newJobList) {
            this.setBasicData(copyJob)
            copyJob.jobUuid = copyJob.uuid
            copyJob.parentUuid = copyJob.lclMasterUuid
            copyJob.path = copyJob.lclMasterUuid + ',' + copyJob.uuid
            copyJob.dateType = 2 // 小票
            this.saveJobNos.push(copyJob)
          }
          this.rowData = [...this.rowData, ...newJobList]
        }
        JobUtils.copyFailTip(copyNum, newJobList, this)
      })
    },
    // 取消编辑
    cancelEdit(done) {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        JobUtils.setCanCloseModuleMap(SystemConstants.CLOSE_MODULE_AE, true, this.job ? this.job.jobNo || '' : '')
        if (typeof done === 'function') {
          done()
        }
      }).catch(() => { })
    },
    saveDefaultVal() {
      this.context.loading = true
      const instance = new EntityDefaultValueUtil(this.$store.getters.currentOfficeId, this)
      instance.saveEntityDefaultValue(['Job', 'AirExportJob', 'CargoDoc'], this.paramsOfTab).then(() => {
        EntityDefaultValueUtil.instanceMap.set(this.$store.getters.currentOfficeId, instance)
        this.$message.success(this.$t('Message.DefaultValuesAreSavedSuccessfully'))
      }).finally(() => {
        this.context.loading = false
      })
    },
    // 刷新
    refresh() {
      this.currentRow.isCompleteRow = false
      this.againShow(this.action, this.job)
    },
    // 加载完job走这里
    initInfo() {
      this.updateControlsState()
      this.showJobState()
      this.showJobTitle()
      this.checkProvisionPublishedStatus()
    },

    // 根据委托状态处理相关权限
    async queryLatestStateHandler(event) {
      const latestState = event.data
      this.btnInfo.privilege.crossMoreSign = latestState < 3
      const company = await Company.getCompanyById(this.job.bookingAgent)
      this.btnInfo.privilege.consignationCrossEnable = company && company.relateTenantId > 0 && company.relateTenantOfficeId > 0
      if (this.job.relatedJob && this.job.relatedJob && company.relateTenantId > 0 && !(latestState < 3)) {
        this.btnInfo.privilege.consignationCrossEnable = false
      }
    },
    // 刷新控制按钮
    updateControlsState() {
      const job = this.currentRow
      if (!job) return
      this.btnInfo.label.shutOutLabel = job.shutOut ? this.$t('SeaExport.CancelShutOut') : this.$t('SeaExport.ShutOut')// this.$t('SeaExport.CancelShutOut') : this.$t('SeaExport.ShutOut')

      // 利润分析打印
      this.btnInfo.visible.profitPrintable = this.btnInfo.visible.cancelable = false
      if (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.COMMITED || job.jobState === SystemConstants.VERIFIED || job.jobState === SystemConstants.PRE_COMMIT) {
        this.btnInfo.visible.profitPrintable = !(job.operateType === AirExportConstants.CONSOLE.code && !job.masterFlag) && (this.$checkPermission(['button_JobBooking_Submit']) || this.$checkPermission(['button_JobBooking_PrintProfit']))
        if (job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.cancelable = this.$checkPermission(['button_AEBooking_cancelProfit']) || this.$checkPermission(['button_JobBooking_Retract'])
        }
      }
      // if (job && job.jobState !== SystemConstants.SHUT_OUT && !job.masterFlag && (job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code || job.containerLoadType === ContainerLoadType.SPECIAL_CARGO_TYPE.code)) {
      //   this.btnInfo.visible.printFclProfit = (this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit)
      // }
      // // 拼箱主票
      // if (job && job.jobState !== SystemConstants.SHUT_OUT && (job.masterFlag || (job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code))) {
      //   this.btnInfo.visible.printLclProfit = (this.btnInfo.privilege.button_JobBooking_Submit || this.btnInfo.privilege.button_JobBooking_PrintProfit)
      // }
      // 撤回权限按钮
      if (this.btnInfo.privilege.button_SEBooking_cancelProfit || this.btnInfo.privilege.button_JobBooking_Retract) {
        this.btnInfo.visible.printReturn = false
        if (!this.isEditing && job && job.jobState === SystemConstants.COMMITED) {
          this.btnInfo.visible.printReturn = true
        }
      }
      // 审核、退回、撤回、提交、预提交、主管提交
      this.btnInfo.visible.btnManagerAuditSubmit = this.btnInfo.privilege.button_JobBooking_ManagerAuditSubmit && job.manageAuditStatus === 1 && (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT)
      this.btnInfo.visible.printReturn = job.jobState === SystemConstants.COMMITED && this.btnInfo.privilege.button_JobBooking_Retract
      this.btnInfo.visible.printReturnOperate = job.jobState === SystemConstants.PRE_COMMIT && this.btnInfo.privilege.button_JobBooking_ReturnToOperater
      this.btnInfo.visible.btnSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_Submit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)
      this.btnInfo.visible.btnManagerSubmit = (job.jobState === SystemConstants.OPERATING || job.jobState === SystemConstants.PRE_COMMIT) && this.btnInfo.privilege.button_JobBooking_ManagerSubmit
      this.btnInfo.visible.btnPreSubmit = job.jobState === SystemConstants.OPERATING && this.btnInfo.privilege.button_JobBooking_PreSubmit && (job.manageAuditStatus === 0 || job.manageAuditStatus === 3)

      this.changeSendBranchBtn()
    },
    // 内部委托按钮label控制
    async changeSendBranchBtn() {
      // 发送分公司控制
      const _job = this.currentRow
      if (!_job) return
      let company = await Company.getCompanyById(_job.bookingAgent)
      this.btnInfo.privilege.sendable = !this.isEditing && company && company.linkedBranchId > 0 && company.linkedBranchId !== _job.opOffice && !_job.relatedJob
      this.btnInfo.visible.btSendBranch = this.btnInfo.privilege.sendable
      if (company) {
        if (!this.btnInfo.privilege.sendable && _job.relatedJob && _job.relatedJob !== '' && _job.relatedJobLob && _job.relatedJobLob !== 'AI') {
          this.btnInfo.label.SendToBranchCompany = this.$t('SeaExport.AssociationBusinessInformation')
          this.btnInfo.visible.btSendBranch = true
        } else {
          this.btnInfo.label.SendToBranchCompany = this.$t('SeaExport.SendToBranchCompany')
        }
      }
      // 出口转进口
      company = await Company.getCompanyById(_job.destinationAgent)
      this.btnInfo.privilege.consignationEnableAI = company && ((company.linkedBranchId > 0 && company.linkedBranchId !== _job.opOffice) ||
        (company.relateTenantId > 0 && company.overseaAgent && _job.jobState === SystemConstants.STATE_OPERATING.code))
      if (company) {
        if (this.btnInfo.privilege.consignationEnableAI && _job.relatedJob && _job.relatedJob !== '' && company.relateTenantId === 0 && _job.relatedJobLob && _job.relatedJobLob === 'AI') {
          this.btnInfo.label.btnEntrustmentAI = this.$t('SeaExport.AssociationBusinessInformationSI')
          this.btnInfo.privilege.consignationEnableAI = !this.isEditing
        } else {
          this.btnInfo.label.btnEntrustmentAI = this.$t('SeaExport.ConsignationSI')
        }
      }
      // 判断是否已做过出口转进口
      if (company) {
        if (this.btnInfo.privilege.consignationEnableAI && _job.relatedJob && _job.relatedJob !== '' && company.relateTenantId === 0 && _job.relatedJobLob && _job.relatedJobLob === 'AI') {
          this.btnInfo.btnEntrustmentAISynchronized = true
        } else {
          this.btnInfo.btnEntrustmentAISynchronized = false
        }
      } else {
        this.btnInfo.btnEntrustmentAISynchronized = false
      }
    },
    returnReview() {
      if (!this.currentRow) {
        return
      }
      JobUtils.batchReturnReview(this, [this.currentRow])
    },
    // 退关
    async toShutOut() {
      if (!this.currentRow) return
      const item = this.currentRow
      if (this.job.jobState === 2) {
        this.$message(this.$t('Message.BusinessHasBeenSubmittedCannotBeShutOut'))
        return
      }
      if (!this.commonInfo.allowShutoutable) {
        const tt = DateUtils.getBetweenDays(new Date(), this.job.ETD)
        if (tt < 0) {
          this.$message(this.$t('queryJob.BusinessTodayIsNotCustoms'))
          return
        }
      }
      if (item.shutOut) {
        await this.$confirm(this.$t('Message.ConfirmToCancelTheShutOut'))
        item.shutOut = false
        item.jobState = SystemConstants.OPERATING
        item.operateNameCode = SystemConstants.OPERATE_CANCEL_SHUTOUT.code
        shutOut({ anyStr: item.uuid, anyBool: item.shutOut, location: this.location }).then(res => this.printResultHandler(res))
      } else {
        canBatchShutout({ jobKeys: [item.uuid] }).then(res => this.shutoutCheckHandler(res))
      }
    },
    // 退关 弹框处理
    shutoutCheckHandler(res) {
      const result = Number(res.data)
      this.shutOutDialog.shutOutButtonShow2 = ''
      if (result === 0) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.CustomsClearanceNoChargeNoChange')
      } else if (result === 1) {
        this.shutOutDialog.shutOutTip1 = this.$t('SeaExport.CustomsClearanceChargeRelatedEdit')
        this.shutOutDialog.shutOutTip2 = this.$t('SeaExport.ClearFeeNoChargeCustomsClearance')
        this.shutOutDialog.shutOutButtonShow2 = 'none'
      } else if (result === 2) {
        this.$message.warning(this.$t('Message.PleaseRemoveThisTicketFromMblThenShutOutBatch'))
      } else if (result === 3) {
        this.$message.warning(this.$t('Message.PleaseRemoveAllTicketsFromMblThenShutOutBatch'))
      }
      if (result === 0 || result === 1) {
        this.shutOutDialog.visible = true
      }
    },
    // 有费用退关
    hasChargeShutoutHandler() {
      const job = this.currentRow
      if (!job) return
      this.shutOutDialog.hasCharge = true
      this.commonInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
      shutOut({ anyStr: job.uuid, anyBool: true, location: this.location }).then(res => this.shutOutResult(res))
    },
    // 无费用退关
    async noHasChargeShutoutHandler() {
      const job = this.currentRow
      if (!job) return
      this.shutOutDialog.hasCharge = false
      this.commonInfo.operateNameCode = Number(SystemConstants.OPERATE_SHUTOUT.code)
      const loading = getLoading4Cxt(this)
      try {
        const body = { job: { ...job }}
        delete body.job.containerUsages
        delete body.job.containers
        const result = await JobUtils.checkBySaveJobNode(body, this.job.lob, CheckRuleConstants.NO_FEE_REFUND.code)
        if (result.needShowDialog) {
          loading.close()
          const callBack = async() => { shutOut({ anyStr: job.uuid, anyBool: false, location: this.location }).then(res => this.shutOutResult(res)) }
          this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NO_FEE_REFUND.code
          this.checkingSaveJobWindow.rowData = result.rowData
          this.checkingSaveJobWindow.callBack = callBack
          this.checkingSaveJobWindow.visible = true
        } else {
          shutOut({ anyStr: job.uuid, anyBool: false, location: this.location }).then(res => this.shutOutResult(res))
        }
      } catch (err) {
        throw err
      } finally {
        loading.close()
      }
    },
    // 退关结果处理
    shutOutResult(res) {
      //   const j = res.data
      //   if (!j) return
      //   const msg = j.shutOut ? this.$t('Message.ShutOutSuccessfully') : this.$t('Message.CancelShutOutSuccessfully')
      //   this.$confirm(msg, this.$t('common.tips.prompt'), {
      //     confirmButtonText: this.$t('common.btn.ok'),
      //     showCancelButton: false,
      //     closeOnClickModal: false,
      //     showClose: false,
      //     center: true,
      //     type: 'success'
      //   }).then(() => {
      //     if (this.commonInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
      //       this.currentRow.jobState = SystemConstants.OPERATING
      //       this.currentRow.shutOut = false
      //     } else {
      //       const hasCharge = this.shutOutDialog.hasCharge
      //       this.currentRow.shutOut = true
      //       if (!hasCharge) {
      //         this.currentRow.jobState = SystemConstants.SHUT_OUT
      //       }
      //     }
      //     this.saveJobNos.push(this.currentRow)
      //     this.refresh()
      //   })
      //   this.shutOutDialog.visible = false
      // CARGO-32950 退关后，弹框要改为提示
      const j = res.data
      if (!j) return
      if (j.shutOut) {
        this.$message.success(this.$t('Message.ShutOutSuccessfully'))
      } else {
        this.$message.success(this.$t('Message.CancelShutOutSuccessfully'))
      }
      if (this.commonInfo.operateNameCode === Number(SystemConstants.OPERATE_CANCEL_SHUTOUT.code)) {
        this.currentRow.jobState = SystemConstants.OPERATING
        this.currentRow.shutOut = false
      } else {
        const hasCharge = this.shutOutDialog.hasCharge
        this.currentRow.shutOut = true
        if (!hasCharge) {
          this.currentRow.jobState = SystemConstants.SHUT_OUT
        }
      }
      this.saveJobNos.push(this.currentRow)
      this.refresh()
      this.shutOutDialog.visible = false
    },
    // 作废/取消作废
    printResultHandler(result) {
      this.$message.success('操作成功')
      this.updateControlsState()
      // 重新加载
      this.refresh()
    },
    // 业务状态显示
    showJobState() {
      if (!this.currentRow || !this.currentRow.uuid) {
        this.commonInfo.jobState = ''
        this.commonInfo.jobLock = ''
        this.commonInfo.jobChangeState = ''
        return
      }
      this.commonInfo.jobState = ColumnUtils.getJobState(this.currentRow)
      this.commonInfo.jobLock = JobUtils.isBlockJob(this.currentRow) ? this.$t('Message.Locked') : ''
      // 改单状态
      if (Number(this.config.get('IsCommittedAllowAddCost')) === 1) {
        this.commonInfo.jobChangeState = ColumnUtils.getJobChangeState2(this.currentRow)
      }
    },
    /** 详情标题中段：插在业务编号与委托方信息之间（订舱主单号 mbl，空为 -，与 tab 展示一致格式化） */
    formatAeJobTitleMawbSegment(job) {
      if (!job) return '-'
      const raw = job.mbl != null && String(job.mbl).trim() !== '' ? job.mbl : job.MBL_NO != null ? job.MBL_NO : ''
      const s = String(raw).trim()
      if (!s) return '-'
      return AirExportUtils.mawbNoDispalyFormat(s) || '-'
    },
    async showJobTitle() {
      const job = this.currentRow
      let jobTitle = (Number(this.config.get('DetailTitleShowModel')) || 0) === 0 ? job.jobNo : StrUtils.toHalfwordUpperCase(job.mbl)
      let chargeJobTitle = ''
      if (this.isEditing) {
        const methodPath = this.documentManage.getPath('showBasicInfo')
        chargeJobTitle = jobTitle + `<i title="${this.$t('SeaExport.TipCharge')}" class="el-icon-search" style="margin-left:5px;color:#0000FF;cursor:pointer" onclick="${methodPath}()"></i>`
      }
      const detailModel = Number(this.config.get('DetailTitleShowModel')) || 0
      const mawbMid = detailModel === 0 ? this.formatAeJobTitleMawbSegment(job) : null

      if (job.customerId) {
        const cmp = await Company.getCompanyById(job.customerId)
        if (cmp) {
          const creditTerm = await JobUtils.getSettlementTypeByJobInformation(job, 'customerId')
          const billingType = await JobUtils.getBillingTypeByCompany(cmp)
          const name = this.$store.getters.language === 'zh' ? cmp.chineseName : cmp.englishName
          if (detailModel === 0) {
            jobTitle =
              '<span style="margin-right:10px">' +
              jobTitle +
              '</span><span style="margin-right:10px">' +
              mawbMid +
              '</span><span style="margin-right:10px">' +
              name +
              creditTerm +
              '</span><span>' +
              billingType +
              '</span>'
            if (this.isEditing) {
              chargeJobTitle =
                '<span style="margin-right:10px">' +
                chargeJobTitle +
                '</span><span style="margin-right:10px">' +
                mawbMid +
                '</span><span style="margin-right:10px">' +
                name +
                creditTerm +
                '</span><span>' +
                billingType +
                '</span>'
            }
          } else {
            jobTitle = '<span style="margin-right:10px">' + jobTitle + '</span><span style="margin-right:10px">' + name + creditTerm + '</span><span>' + billingType + '</span>'
            if (this.isEditing) {
              chargeJobTitle =
                '<span style="margin-right:10px">' +
                chargeJobTitle +
                '</span><span style="margin-right:10px">' +
                name +
                creditTerm +
                '</span><span>' +
                billingType +
                '</span>'
            }
          }
        }
      }
      this.commonInfo.jobTitle = jobTitle
      this.commonInfo.chargeJobTitle = chargeJobTitle
    },
    // 检查计提发布状态
    async checkProvisionPublishedStatus() {
      if (!this.job || !this.job.uuid) {
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
        return
      }

      try {
        const res = await checkJobProvisionFlag(this.job.uuid)
        this.commonInfo.provisionLock = res.ok ? normalizeProvisionLock(res.data) : { etdLocked: false, feeLocked: false }
      } catch (error) {
        console.error('检查计提发布状态失败:', error)
        this.commonInfo.provisionLock = { etdLocked: false, feeLocked: false }
      }
    },
    showBasicInfo() {
      this.basicInfoVisible = !this.basicInfoVisible
      this.showBasicInfoWindow()
    },
    showBasicInfoWindow() {
      if (this.basicInfoVisible) {
        const job = this.paramsOfTab
        this.basicInfo.rowData = [
          { basic: this.$t('SeaExport.Mbl2') + ':', isTitle: true },
          { basic: job.mbl || '', isTitle: false },
          { basic: this.$t('SeaExport.DateOfDeparture') + ':', isTitle: true },
          { basic: job.etd ? ColumnUtils.dateLabelFunc(job.etd) : '', isTitle: false },
          { basic: this.$t('SeaExport.CommissionedGrossWeight') + ':', isTitle: true },
          { basic: job.weightContract ? ColumnUtils.numberColumnLabelFunc(job.weightContract, 3) : '', isTitle: false },
          { basic: this.$t('SeaExport.CommissionedVolume') + ':', isTitle: true },
          { basic: job.cubageContract ? ColumnUtils.numberColumnLabelFunc(job.cubageContract, 3) : '', isTitle: false },
          { basic: this.$t('SeaExport.CommissionedChargedWeight') + ':', isTitle: true },
          { basic: job.chargeWeight ? ColumnUtils.numberColumnLabelFunc(job.chargeWeight, 3) : '', isTitle: false },
          { basic: this.$t('SeaExport.ActualChargedWeight') + ':', isTitle: true },
          { basic: job.cWeight ? ColumnUtils.numberColumnLabelFunc(job.cWeight, 3) : '', isTitle: false },
          { basic: this.$t('SeaExport.Remarks') + ':', isTitle: true },
          { basic: job.remarks || '', isTitle: false }
        ]
      }
    },
    // 复制
    toCopy() {
      if (this.job.masterFlag) {
        this.$emit('copy', this.job)
        return
      }
      if (this.job.customerId) {
        isContractExpiredForbidCreateJob(this.job.customerId).then(res => {
          if (res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.$emit('copy', this.job)
          }
        })
      }
    },
    importOrder() {
      if (!this.job) return
      if (JobUtils.checkHQ()) return
      this.importOrderDialog.job = this.job
      this.importOrderDialog.visible = true
    },
    importOrderConfirmCallBack(data) {
      if (!data) return
      const selectedJob = data.job
      const selectedTabs = data.selectedTabs
      const item = {}
      item.sourceJobUuid = selectedJob.uuid
      item.targetJobUuid = this.currentRow.uuid
      item.branchId = this.$store.getters.currentOfficeId
      if (selectedTabs) {
        item.mbl = selectedTabs.mbl
        item.hbl = selectedTabs.hbl
        item.charge = selectedTabs.charge
        item.overwritesDifference = selectedTabs.isOverwritesDifference
      }
      const loading = getLoading4Cxt(this)
      importOrderJob(item).then(async res => {
        if (res.data) {
          const result = res.data
          const newJob = result.job
          newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice

          const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'AeBooking')
          if (!continueExec) {
            return
          }
          this.writeBackJob(newJob)
          this.currentRow.differenceJobFields = result.airJobDifferenceTab
          this.currentRow.differenceMawbFields = result.mawbDifferenceTab
          this.currentRow.differenceHawbFields = result.hawbDifferenceTab
          this.againShow('edit', this.currentRow)
        }
      }).finally(() => {
        loading.close()
      })
    },
    writeBackJob(data) {
      for (const key in data) {
        this.currentRow[key] = data[key]
      }
    },
    // 预提交
    doSubmitPrint_PreSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_PRE_COMMIT.code)
    },
    // 提交
    doSubmitPrint_Submit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_COMMIT.code)
    },
    // 主管提交
    doSubmitPrint_ManagerSubmit() {
      this.doSubmitPrintPROFIT(CheckRuleConstants.NODE_MANAGER_COMMIT.code)
    },
    // 主管审核
    async doSubmitAudit_ManagerSubmit() {
      this.optName = ''
      const checkApChargeVerify = parseInt(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }

      const callBack = this.getDoSubmitAudit_ManagerSubmit || null
      const callBack2 = this.getDoSubmitAudit_ManagerSubmit2 || null
      const checkNode = 10
      this.checkingManager(checkNode, callBack, callBack2)
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit() {
      commit(this.job.uuid, SystemConstants.OPERATE_SUBMISSION.code, false, this.office.officeId, this.location).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
      })
    },
    // 主管审核【验证规则回调函数】
    getDoSubmitAudit_ManagerSubmit2() {
      this.commonInfo.showMessage = false
      this.loadChargesPrintReturnHandler()
    },
    // 主管审核【验证规则回调函数】
    async loadChargesPrintReturnHandler() {
      const charges = await new AirExportJob(this.job).getCharges()
      this.refChargeChargeState(charges)
      this.job.jobState = SystemConstants.OPERATING
      this.job.submissionDate = null
      this.job.manageAuditStatus = 0
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        if (this.commonInfo.showMessage) {
          this.$message.warning(this.$t('Message.AlreadyWithdraw'))
        } else {
          this.commonInfo.showMessage = true
        }
      })
    },
    // 保存之前将不需要保存的数据置空,后续需要使用时再加载 this.refresh() 会再走加载那一段
    // 避免循环引用
    resetNoNeedSaveData() {
      if (Object.prototype.hasOwnProperty.call(this.job, 'unitLoadDeviceUsages')) {
        for (const usage of this.job.unitLoadDeviceUsages) {
          delete usage.unitLoadDevice
        }
      }
      if (Object.prototype.hasOwnProperty.call(this.job, 'unitLoadDevices')) {
        for (const container of this.job.unitLoadDevices) {
          delete container.unitLoadDeviceUsage
        }
      }
    },
    // node 提交 检测的节点【预提交/提交/主管提交】
    async doSubmitPrintPROFIT(node) {
      this.optName = ''
      const job = this.job
      await new AirExportJob(job).getCharges()
      await new AirExportJob(job).getLclSlaves()
      // sap 交单验证结算公司
      if (this.commonInfo.openSapConfig) {
        if (job.charges && job.charges.length > 0) {
          for (const c of job.charges) {
            if (!c.settleDepartmentPrefix) {
              this.$message.warning(this.$t('Message.escnm2'))
              return
            }
          }
        }
      }

      if (node === CheckRuleConstants.NODE_COMMIT.code || node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        // 预付款余额校验
        const checkFailUuids = []
        const jobKeys = []
        jobKeys.push(job.uuid)
        const continueExec = await JobUtils.checkBalanceBeforeSubmitHandler(jobKeys, checkFailUuids)
        if (!continueExec) {
          return
        }
        // 余额不足
        if (checkFailUuids && checkFailUuids.indexOf(job.uuid) !== -1) {
          return
        }
      }
      this.commonInfo.isPreCommit = node === CheckRuleConstants.NODE_PRE_COMMIT.code
      if (node === CheckRuleConstants.NODE_PRE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_SUBMISSION.code
      } else if (node === CheckRuleConstants.NODE_MANAGER_COMMIT.code) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_MANAGER_SUBMISSION.code
      }

      this.commonInfo.isPrintOpr = false
      const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
      if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
        const isPass = await JobUtils.checkChargeStateVerify(this.job)
        if (!isPass) {
          this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
          return
        }
      }

      // 判断是否开启验证规则
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, node, job.opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        let commitSuccess = this.commitResultHandler || null
        if (this.commonInfo.openSapConfig && this.commonInfo.isPreCommit) {
          commitSuccess = this.commitSapResultHandler
        }
        if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
          (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code ||
            this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code)) {
          commitSuccess = this.commitCBMSResultHandler
        }
        if (this.commonInfo.openHecConfig) {
          commitSuccess = this.commitHecSapResultHandler
        }
        const callBack = async() => {
          // CARGO-32805 BPM流程引擎二期，提交
          if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
            return
          }
          commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.office.officeId, this.location).then(res => {
            commitSuccess(res)
          })
        }
        const callback2 = this.commitRefuseHandler || null
        const checkNode = node
        this.checkingManager(checkNode, callBack, callback2)
      } else {
        if (job.jobState === SystemConstants.PRE_COMMIT) {
          // CARGO-32805 BPM流程引擎二期，提交
          if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
            return
          }
          job.operateNameCode = this.commonInfo.operateNameCode
          submitState({ 'jobKey': job.uuid, 'operateNameCode': this.commonInfo.operateNameCode, location: this.location }).then(async res => {
            this.$emit('reloadJob', job)
            this.commonInfo.isPrint = false
            this.commonInfo.isPrintOpr = false
            this.$message.success(this.$t('Message.CommitSuccessfully'))
          })
          return
        }
        this.commonInfo.isPrint = false
        await this.calculateProfit2()
      }
    },
    async calculateProfit2() {
      const pass = await this.checkOverseaBilling(this.job)
      if (!pass) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable') : this.$t('Message.WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted')
        this.$message.warning(msg)

        return
      }
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, null, null, this.job)) {
        return
      }
      // 预提交/提交直接显示已提交，不显示利润打印弹窗
      if (Number(this.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler2(res))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler2(res))
      }
    },
    async calculateResultHandler2(res) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      this.refreshChargeHandler(oldJobState)
      this.refresh()
    },
    async checkOverseaBilling(job) {
      let pass = true
      const useCheckRule = Number(this.config.get('useCheckRule'))
      job.charges = ''
      await new AirExportJob(job).getCharges()
      if (job.charges && job.charges.length > 0) {
        for (const charge of job.charges) {
          if (charge.oversea && !charge.paidOff) {
            // cargo-649 当未开启验证引擎参数的时候，去判断如果是红冲票，过滤掉
            if (useCheckRule === 0 && charge.offsetState !== 0) {
              continue
            }
            if (!charge.billNo) {
              pass = false
              break
            }
          }
        }
      }
      if (pass && job.lclSlaves && job.lclSlaves.length > 0) {
        for (const slave of job.lclSlaves) {
          pass = this.checkOverseaBilling(slave)
          if (!!pass === false) { break }
        }
      }
      return pass
    },
    profitPreviewPrintHander() {
      const category = this.job.operateType === AirExportConstants.CONSOLE.code ? 'AEPROFIT2' : 'AEPROFIT'
      this.previewProfit({}, category)
    },
    /**
     * 开启sap推送 发送sap消息
     * @private
     */
    commitSapResultHandler() {
      const jobs = []
      jobs.push(this.job.key)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.key)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = ChargeUtils.CHARGE_NULL.code
      params.sapStatus = ChargeUtils.CHARGE_SH.code
      params.needUpdateCharge = true
      const self = this
      sendSapMessageByJob(params).then(res => {
        self.$message.success(self.$t('Message.SapSynchronizationSuccess'))
        self.commitRefuseHandler()
      })
    },
    async commitHecSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = ChargeUtils.CHARGE_US.code
      params.sapStatus = ChargeUtils.CHARGE_SH.code
      params.needUpdateCharge = true
      params.isSend = false
      await sendHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResultHandler(res)
      })
    },
    async backReturnSapResultHandler(res) {
      const jobs = []
      jobs.push(this.job.uuid)
      if (this.job.masterFlag && this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          jobs.push(j.uuid)
        }
      }
      const params = {}
      params.jobKey = jobs
      params.oldSapStatus = 'all'
      params.sapStatus = ChargeUtils.CHARGE_US.code
      params.needUpdateCharge = true
      params.isSend = false
      await backHecMessageByJob(params).then(rsp => {
        this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
        this.commitResult2Handler(res)
      })
    },
    /**
     * 开启CBMS推送 发送CBMS消息
     * @private
     */
    async commitCBMSResultHandler(res, type = '0') {
      const params = {}
      params.uuid = this.job.uuid
      params.isDisable = type
      params.officeId = this.$store.getters.currentOfficeId
      await sendJobCBMS(params).then(rsp => {
        if (!rsp.data || rsp.data === 'fail') {
          this.$message.error(this.$t('CargoMsg.Cargo_PushFailByCBMS'))
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_PushSuccessByCBMS'))
        }
        this.commitResult2Handler(res)
      })
    },
    // 提交【验证规则回调函数】
    getDoSubmitPrintPROFIT() {
      const job = this.job
      const checkChargeInvoice = Number(this.config.get('CheckReceivableChargePrintInvoice'))
      if (this.commonInfo.isPreCommit || checkChargeInvoice < 1) {
        commit(job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPreCommit, this.office.officeId, this.location).then(res => this.commitResultHandler(res))
      } else {
        getChargeIsInvoice(job.uuid).then(res => this.getChargeIsInvoiceResult(res))
      }

      this.refreshLeftTree()
    },
    // 提交【验证规则回调函数】
    async commitResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.CommitSuccessfully'))
      this.refresh()
    },
    async commitResult2Handler(res) {
      await this.mergeCurrentRow(res)
      this.refresh()
    },
    // 提交主票，小票一起提交
    async doSubmitAllFcl() {
      if (this.job.lclMasterUuid) {
        this.$message.warning(this.$t('Message.LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL'))
        return
      } else if (this.job.masterFlag) {
        await this.getLclSlavesAndCharges()
        this.loadSubmitAllFclHandler()
      } else {
        this.doSubmitPrint()
      }
    },
    // 根据主票加载小票以及小票费用
    async getLclSlavesAndCharges() {
      await new AirExportJob(this.job).getCharges()
      const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const lclJob of lclSlaves) {
          if (lclJob.uuid && !lclJob.charges) {
            await new AirExportJob(lclJob).getCharges()
          }
        }
      }
    },
    // 提交主票
    async loadSubmitAllFclHandler() {
      await RateUtil.refreshChargeRatesByJob(this.job)
      this.job.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
      for (const c of this.job.charges) {
        c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
      }
      for (const lclJob of this.job.lclSlaves) {
        lclJob.jobState = this.commonInfo.isPreCommit ? SystemConstants.PRE_COMMIT : SystemConstants.COMMITED
        if (!this.commonInfo.isPreCommit) {
          for (const c of lclJob.charges) {
            c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
          }
        }
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        // 保存job相关信息【saveJobInfo = save2】
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.$message.success(this.$t('Message.CommitSuccessfully'))
          this.refresh()
        })
      } else {
        // 保存刷新过的的汇率 by Marco 2014-8-8 (Bad Design)
        this.resetNoNeedSaveData()
        await saveJobInfo(this.job).then(async res => {
          await this.mergeCurrentRow(res)
          this.commonInfo.isPrint = false
          if (this.btnInfo.visible.printFclProfit) {
            this.checkPrintEnable(this.doPrintFCLPROFIT)
          } else {
            this.checkPrintEnable(this.doPrintLCLPROFIT)
          }
        })
      }
    },
    // 整箱利润打印提交
    async doPrintFCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewFCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewFCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印提交
    async doPrintLCLPROFIT(isProfitPrint = false) {
      // 当是整/拼箱利润打印按钮事件且 PrintProfitToPreCommit=1或2时，先打印再提交
      if (isProfitPrint && [1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.previewLCLProfit({ data: this.job }, isProfitPrint)
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrintOpr, this.commonInfo.allSubmitFcl, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.previewLCLProfit(res, isProfitPrint))
      }
    },
    // 拼箱利润打印预处理
    previewLCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'LCL', isProfitPrint)
    },
    // 整箱利润打印预处理
    previewFCLProfit(res, isProfitPrint) {
      this.previewProfit(res, 'FCL', isProfitPrint)
    },
    // 预览打印【区分整箱拼箱】
    async previewProfit(res, type, isProfitPrint = false) {
      await this.mergeCurrentRow(res)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "LCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      // TemplateSelectorWin.getInstance().showThisWin(this.job, "FCLPROFIT", params, this, null, this.doPrintPROFIT, this.doPrintPROFIT_V2)
      if (isProfitPrint) {
        this.$nextTick(() => {
          const params = {}
          params.jobuuid = this.job.uuid
          params.showPreview = this.commonInfo.isPrint
          params.JOB_UUID = this.job.uuid

          params.isPreCommit = this.commonInfo.isPreCommit
          console.log(type + '-previewProfit--params--', params)
          this.templateSelectorDialog.ctx = new AirExportJob(this.job)
          this.templateSelectorDialog.category = type
          this.templateSelectorDialog.data = params
          // 组装打印回调函数
          this.prePrintCallback = null
          this.printedCallback = this.doPrintPROFIT
          this.v2CheckCallback = this.doPrintPROFIT_V2
          this.templateSelectorDialog.visible = true
        })
      } else {
        // 预提交/提交直接显示已提交，不显示利润打印弹窗
        if (Number(this.config.get('useCheckRule')) === 1) {
          printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        } else {
          calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateResultHandler(res))
        }
      }
      this.updateControlsState()
      this.refresh()
    },
    async calculateResultHandler(res) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      this.refreshChargeHandler(oldJobState)
      this.refresh()
    },
    // 打印回调函数
    doPrintPROFIT(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPreCommit = event.isPreCommit

      if (PrintUtils.isExecutor(event.action)) {
        if (this.job && this.job.uuid) {
          // 检查是否有收费用未开发票
          if (this.job.jobState === SystemConstants.OPERATING) {
            getChargeIsInvoice(this.job.uuid).then(res => this.getChargeIsInvoiceResult(res, true))
          } else {
            this.printAlert(true)
          }
        }
      }
    },
    // 打印回调函数
    doPrintPROFIT_V2(isSure, template, entity, arms) {
      if (isSure && arms) {
        this.commonInfo.isPreCommit = arms.event.isPreCommit
        if (PrintUtils.isExecutor(arms.event.action)) {
          this.printAlert(true)
        }
      }
    },
    // 确认是否可打印
    checkPrintEnable(callback) {
      if (this.job && !this.job.masterFlag && this.job.sales <= 0 && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const msg = this.commonInfo.isPrint ? this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndPrints')) : this.$message.warning(this.$t('Message.PleaseInputTheSalesInformationAndSubmit'))
        this.$message.warning(msg)
        return
      }
      const jobNos = this.checkSales()
      if (jobNos.length > 0) {
        const msg1 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndPrint')
        const msg2 = this.$t('Message.FollowingTheSingleDidNotEnterTheSalesInformation') + ':\n' + jobNos.join('\n') + '\n' + this.$t('Message.PleaseEnterAndSubmit')
        this.$message.warning(this.commonInfo.isPrint ? msg1 : msg2)
        return
      }
      callback()
    },
    // 验证销售及揽货类型
    checkSales() {
      const jobNos = []
      if (!this.job.lclSlaves) {
        for (const j of this.job.lclSlaves) {
          if (j.sales <= 0 && j.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
            jobNos.push(j.jobNo)
          }
        }
      }
      return jobNos
    },
    // 正常提交
    async doSubmitPrint() {
      if (this.job.jobState === SystemConstants.PRE_COMMIT) {
        if (this.job.uuid && !this.job.charges) {
          await new AirExportJob(this.job).getCharges()
        }
        await this.loadChargeHandler()
        return
      }
      this.commonInfo.isPrint = false
      if (this.btnInfo.visible.printFclProfit) {
        this.checkPrintEnable(this.doPrintFCLPROFIT)
      } else {
        this.checkPrintEnable(this.doPrintLCLPROFIT)
      }
    },
    // 加载当前业务的费用
    async loadChargeHandler() {
      this.job.jobState = SystemConstants.COMMITED
      for (const c of this.job.charges) {
        if (c.chargeState === BillingConstants.CHARGE_STATE_NORMAL.code) {
          c.chargeState = BillingConstants.CHARGE_STATE_SUBMIT.code
        }
        const localCurrency = RateUtil.localCurrencyByOfficeId(c.branchId)
        // 刷新汇率
        c.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, c.currency, this.job, c.branchId)
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.$message.success(this.$t('Message.CommitSuccessfully'))
        this.refresh()
      })
    },
    // 打印回调函数
    commitRefuseHandler() {
      this.refresh()
      this.refreshLeftTree()
    },
    // 检查是否有收费用未开发票
    async getChargeIsInvoiceResult(res, isProfitPrint = false) {
      const flag = res.data
      if (flag) {
        const msg = this.commonInfo.isPrint ? this.$t('Message.ThereAreFeesReceivableNotInvoicedPrint') : this.$t('Message.ThereAreFeesReceivableNotInvoicedSubmit')
        await this.$confirm(msg, this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          await this.printAlert(isProfitPrint)
        }).catch(() => {
          this.commonInfo.isPrint = true
        })
      } else {
        await this.printAlert(isProfitPrint)
      }
    },
    // 打印提示
    async printAlert(isProfitPrint = false) {
      const printProfitToPreCommit = Number(this.config.get('PrintProfitToPreCommit'))
      if (printProfitToPreCommit === 0 ||
        this.job.jobState === SystemConstants.SHUT_OUT || this.job.jobState === SystemConstants.VERIFIED || this.job.jobState === SystemConstants.COMMITED ||
        (this.job.jobState === SystemConstants.PRE_COMMIT && printProfitToPreCommit === 1)) {
        this.onConfirmedPrintProfit(isProfitPrint)
      } else if (!isProfitPrint) {
        // 非利润打印，预提交/提交不显示确认框
        this.onConfirmedPrintProfit(isProfitPrint)
      } else {
        let msg = this.$t('Message.VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        if (this.commonInfo.isPreCommit) {
          msg = this.$t('Message.SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue')
        }
        await this.$confirm(msg, this.$t('common.tips.warning'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          this.onConfirmedPrintProfit(isProfitPrint, true)
        }).catch({})
      }
    },
    // 提交/预提交
    async onConfirmedPrintProfit(isProfitPrint = false, isPrint = false) {
      // CARGO-32805 BPM流程引擎二期，提交
      if (await WorkflowUtil.jobSubmitBpm(this, this.commonInfo.operateNameCode, isProfitPrint, this.config, this.job)) {
        return
      }
      // 利润打印 按钮逻辑
      // if (isProfitPrint) {
      //   calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      //   return
      // }
      // 预提交/提交/主管提交 按钮逻辑
      if (Number(this.config.get('useCheckRule')) === 1) {
        printProfit(this.job.uuid, this.commonInfo.operateNameCode, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      } else {
        calculateProfit(this.job.uuid, this.commonInfo.operateNameCode, this.commonInfo.isPrintOpr, true, this.commonInfo.isPreCommit, this.office.officeId, this.optName, this.location).then(res => this.calculateProfit2ResultHandler(res, isProfitPrint, isPrint))
      }
    },
    // 提交成功
    async calculateProfit2ResultHandler(res, isProfitPrint = false, isPrint = false) {
      this.optName = ''
      const oldJobState = this.job.jobState
      await this.mergeCurrentRow(res)
      if ((!isProfitPrint || isPrint) && this.commonInfo.printEvent && !PrintUtils.isPrint(this.commonInfo.printEvent.action)) {
        const template = this.commonInfo.printEvent.template
        const parameter = this.commonInfo.printEvent.parameter
        let documentType = null
        if (template && template.documentTypeUuid || !Object.prototype.hasOwnProperty.call(parameter, 'documentType') || !parameter.documentType) {
          await getDocumentType(template.documentTypeUuid).then(res => {
            documentType = res.data ? res.data : null
          })
        }
        if (StimulSoftUtil.isOpenStiReport(template)) {
          parameter.designMode = this.$checkPermission(['role_template_design']) ? 1 : 0
          parameter.documentType = documentType
          await StimulSoftUtil.stiReportPreview(template, this.job, parameter)
        } else {
          const action = this.commonInfo.printEvent.action || ''
          const format = this.commonInfo.printEvent.format || ''
          const url = await PrintTemplateManager.print(template, documentType, format, parameter, action === PrintUtils.PRINT)
          if (url) {
            await this.loadMailURL(url, parameter)
          }
        }
      }
      // 提交成功推送费用
      if (this.commonInfo.operateNameCode === SystemConstants.OPERATE_SUBMISSION.code || this.commonInfo.operateNameCode === SystemConstants.OPERATE_MANAGER_SUBMISSION.code) {
        if (this.commonInfo.openHecConfig) {
          const jobs = []
          jobs.push(this.job.uuid)
          if (this.job.masterFlag && this.job.lclSlaves) {
            for (var j of this.job.lclSlaves) {
              jobs.push(j.uuid)
            }
          }
          const params = {}
          params.jobKey = jobs
          params.oldSapStatus = ChargeUtils.CHARGE_US.code
          params.sapStatus = ChargeUtils.CHARGE_SH.code
          params.needUpdateCharge = true
          params.isSend = false
          await sendHecMessageByJob(params).then(rsp => {
            this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
          })
        }
      }
      this.refreshChargeHandler(oldJobState, isProfitPrint)
      this.refresh()
    },
    // 加载MailURLRequest
    async loadMailURL(url, parameter) {
      let status = -1
      const request = new XMLHttpRequest()
      request.open('GET', url, false) // false 同步，默认异步【此处需要同步，需要拿status判断做后续处理】
      request.onload = function(e) {
        status = e.target.status
      }
      request.onerror = function(e) {
        this.loadError()
      }
      request.send()
      if (Object.prototype.hasOwnProperty.call(parameter, 'showPreview') && parameter.showPreview) {
        this.httpResultEmail(status)
      }
    },
    // Mail异常结果处理
    httpResultEmail(status) {
      // 附件过大
      if (status === 0) {
        this.$message.error('附件内容过大')
      } else if (status === 1) {
        this.$message.error(this.$t('SeaExport.SmtpServerError'))
      } else if (status === 2) {
        this.$message.error(this.$t('SeaExport.NotConnectSmtpServer'))
      } else if (status === 3) {
        this.$message.error(this.$t('SeaExport.NotFindFile'))
      } else if (status === 4) {
        this.$message.error(this.$t('SeaExport.SendFileError'))
      } else if (status === 5) {
        this.$message.error(this.$t('SeaExport.AttachTemplateError'))
      } else if (status === 200) {
        this.$message.success(this.$t('SeaExport.MailSentSuccess'))
      }
    },
    // 刷新Tab
    refreshChargeHandler(oldJobState = -2, isProfitPrint = false) {
      if (!this.commonInfo.isPreCommit) {
        this.refresh()
      }
      this.commonInfo.isPrint = true
      this.commonInfo.isPrintOpr = false
      if (isProfitPrint && oldJobState === SystemConstants.COMMITED) return // 如果是已提交状态再整箱利润打印，就不需要再弹出提交成功提示
      if (isProfitPrint && oldJobState === SystemConstants.PRE_COMMIT) return
      if (isProfitPrint && Number(this.config.get('PrintProfitToPreCommit')) === 0) return // 如果是打印按钮事件 且printProfitToPreCommit=0，不再弹出提交成功提示
      this.$message.success(this.$t('Message.CommitSuccessfully'))
    },
    // // CARGO-46883
    async sendBranchHandlerPre() {
      if (this.btnInfo.label.SendToBranchCompany === this.$t('SeaExport.SendToBranchCompany')) {
        // 判断是否开启验证规则
        const checkNode = CheckRuleConstants.NODE_CROSS_DELEGATION.code
        const useCheckRule = Number(this.config.get('useCheckRule')) === 1
        if (useCheckRule) {
          const hasCheckRule = await JobUtils.hasConfigCheckRule(checkNode, this.job.uuid, this.job.lob)
          if (hasCheckRule) {
            this.checkingWindow.checkNode = checkNode
            this.checkingWindow.callBack = this.sendBranchHandler
            this.checkingWindow.callBack2 = null
            this.checkingWindow.visible = true
          } else {
            await this.sendBranchHandler()
          }
        } else {
          await this.sendBranchHandler()
        }
      } else {
        await this.sendBranchHandler()
      }
    },
    // 发送分公司
    async sendBranchHandler() {
      this.enableEntrustmentAI = false
      if (this.btnInfo.privilege.sendable) {
        this.loading = getLoading4Cxt(this)
        await this.sendCompany() // 发送分公司
      } else {
        this.queryTrustFrom() // 查看关联业务信息
      }
    },
    async sendCompany(event) {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        // 检索属于订舱代理所属分公司的合作伙伴ID
        queryCompany(1, this.job.opOffice).then(async res => await this.queryCompanyResultHandler(res)).catch(() => { this.closeLoading() })
      }
    },
    // 检索属于订舱代理所属分公司的合作伙伴ID
    async queryCompanyResultHandler(event) {
      const companyArr = event.data
      if (companyArr && companyArr.length > 0) {
        this.partner = companyArr[0]
        // 加载联系人
        await new Company(this.partner).getContacts().catch(() => { this.closeLoading() })
        await this.loadContractsResultHandler()
      } else {
        if (this.enableEntrustmentAI) {
          this.$message.info(this.$t('Message.TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI'))
        } else {
          this.$message.info(this.$t('Message.TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership'))
        }
        this.closeLoading()
      }
    },
    // 加载联系人
    async loadContractsResultHandler() {
      await this.doSendBranch()
    },
    // 发送分公司
    async doSendBranch() {
      const company = await Company.getCompanyById(this.enableEntrustmentAI ? this.job.destinationAgent : this.job.bookingAgent).catch(() => { this.closeLoading() })
      if (company) {
        const office = await Office.getOfficeById(company.linkedBranchId).catch(() => { this.closeLoading() })
        this.closeLoading()
        if (office) {
          this.sendBranchWindow.office = office
          this.sendBranchWindow.title = office.chineseName
          if (!this.sendBranchWindow.checkConsigneeDefault) {
            this.sendBranchWindow.consigneeTarget = 'consignee'
            this.sendBranchWindow.consigneeDetailTarget = 'consigneeDetail'
          }
          this.sendBranchWindow.checkSalesMapping = this.showdCheckSalesMapping
          this.sendBranchWindow.visible = true
        }
      }
    },
    // 销售change事件
    async userId_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        await getUserDefaultDepartment({ category: 'role', shape: 'airline', userId: userId }).then(res => this.getDefaultAirLineResult(res, item))
      } else {
        item.departmentId = 0
        item.userId = 0
      }
    },
    // 客服部门
    async getDefaultAirLineResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
    },
    // 发送分公司保存业务
    async enterSendHandler() {
      // 出口转进口
      const loading = getLoading4Cxt(this)
      // 复制一票新的业务以及更新当前业务的relatedJob放在后端[返回修改后的job]
      const item = {}
      if (this.sendBranchSelectObject === 2) {
        if (this.sendBranchWindow.consigneeTarget === 'customer') {
          if (this.job.masterFlag) {
            if (this.job.lclSlaves && this.job.lclSlaves.length > 0) {
              for (const lclSlave of this.job.lclSlaves) {
                const company = lclSlave.consigneeId > 0 ? await Company.getCompanyById(lclSlave.consigneeId).catch(() => { loading.close() }) : null
                if (company) {
                  if (!company.customer) {
                    this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.ConsigneeCustomerNotExist'))
                    loading.close()
                    return
                  }
                } else {
                  this.$message.warning(`【${lclSlave.jobNo}】` + this.$t('queryJob.RecipientNotExist'))
                  loading.close()
                  return
                }
              }
            }
          } else {
            const company = this.job.consigneeId > 0 ? await Company.getCompanyById(this.job.consigneeId).catch(() => { loading.close() }) : null
            if (company) {
              if (!company.customer) {
                this.$message.warning(this.$t('queryJob.ConsigneeCustomerNotExist'))
                loading.close()
                return
              }
            } else {
              this.$message.warning(this.$t('queryJob.RecipientNotExist'))
              loading.close()
              return
            }
          }
        }
        item.consigneeTarget = this.sendBranchWindow.consigneeTarget
        item.consigneeDetailTarget = this.sendBranchWindow.consigneeDetailTarget
      }
      const excludeFileds = []
      for (const item of this.sendBranchWindow.items) {
        if (item.userId) {
          excludeFileds.push(item.selectObject)
        }
      }
      if (this.enableEntrustmentAI) {
        if (!this.job.eta) {
          this.$message.warning(this.$t('SeaExport.DateOfArrival2') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          loading.close()
          return
        }
        item.deptId = this.$store.getters.currentDeptId
        item.branchId = this.$store.getters.currentOfficeId
        item.anyStr = this.sendBranchWindow.items[0].selectObject === 0 ? 'csr' : 'op' // shape
        item.anyBool = this.commonInfo.isCopySellingCharge // isCopySellingCharge
        item.anyInteger = this.sendBranchWindow.items[0].departmentId // departmentId
        item.anyInteger1 = this.sendBranchWindow.items[0].departmentOfficeId // departmentOfficeId
        item.anyInteger2 = this.sendBranchWindow.items[0].userId // userId
        item.anyInteger3 = this.partner.cmpIdx // cmpIdx
        item.anyInteger4 = this.sendBranchWindow.office.officeId // officeId
        item.anyStr1 = this.job.uuid
        item.anyBool1 = this.commonInfo.overwriteJobRefNoBySEconvertSI
        item.anyBool2 = this.commonInfo.chargeSyncNeedConfirm
        if (this.sendBranchWindow.items.length > 1) {
          const item2 = this.sendBranchWindow.items[1]
          item.anyStr2 = item2.selectObject === 0 ? 'csr' : 'op' // shape
          item.anyInteger5 = item2.departmentId // departmentId
          item.anyInteger6 = item2.departmentOfficeId // departmentOfficeId
          item.anyInteger7 = item2.userId // userId
        }
        item.lcoation = this.location
        createImportByExportJob(item).then(res => {
          if (res.data && res.data.relatedJob) {
            getRelatedAiJob(res.data.relatedJob).then(res2 => {
              JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
            })
          }
          this.saveCloneResultHandler(res)
        }).finally(() => {
          loading.close()
        })
      } else {
        if (this.sendBranchWindow.items[0].userId === 0) {
          this.$message.warning('请选择航线!')
          loading.close()
          return
        }
        item.jobUuid = this.job.uuid
        item.currentDeptId = this.$store.getters.currentDeptId
        item.currentOfficeId = this.$store.getters.currentOfficeId
        item.shape = 'airline'
        item.userId = this.sendBranchWindow.items[0].userId
        item.userDepartmentId = this.sendBranchWindow.items[0].departmentId
        item.bookingAgent = this.partner.cmpIdx
        item.linkedBranchId = this.sendBranchWindow.office.officeId
        item.copySellingCharge = this.commonInfo.isCopySellingCharge
        item.lcoation = this.location
        if (this.job.fba) {
          item.anyStr1 = this.job.uuid
          item.anyBool2 = this.commonInfo.chargeSyncNeedConfirm
          item.anyInteger3 = this.partner.cmpIdx // 委托单位
          fbaSaveCloneJob(item).then(res => this.saveCloneResultHandler(res)).finally(() => { loading.close() })
        } else {
          item.checkSalesMapping = this.sendBranchWindow.checkSalesMapping
          if (item.checkSalesMapping) {
            const cloneJob = {
              ...this.job,
              customerId: this.job.bookingAgent,
              designationAgent: 0,
              opOffice: item.linkedBranchId,
              sales: 0,
              salesOffice: 0,
              salesDepartment: 0
            }
            try {
              await JobUtils.loadSalesByJob(cloneJob, true)
            } catch (e) {
              loading.close()
            }
            item.sales = cloneJob.sales
            item.salesOffice = cloneJob.salesOffice
            item.salesDepartment = cloneJob.salesDepartment
          }
          saveEntrustedByBranch(item).then(res => {
            if (res.data && res.data.relatedJob) {
              getTrustFromJob(res.data.relatedJob).then(res2 => {
                JobUtils.matchPresetConfigAndSave(res2.data, excludeFileds)
              })
            }
            this.saveCloneResultHandler(res)
          }).finally(() => { loading.close() })
        }
      }
      this.sendBranchWindow.visible = false
      this.refresh()
    },
    async saveCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
      if (this.enableEntrustmentAI) {
        this.btnInfo.label.btnEntrustmentAI = this.$t('SeaExport.AssociationBusinessInformationSI')
        this.btnInfo.btnEntrustmentAISynchronized = true
      } else {
        this.btnInfo.label.btnEntrustment = this.$t('SeaExport.AssociationBusinessInformation')
        this.btnInfo.label.SendToBranchCompany = this.$t('SeaExport.AssociationBusinessInformation')
        this.changeSendBranchBtn()
      }
      this.sendBranchWindow.items[0].userId = 0
      this.sendBranchWindow.office = {}
      this.sendBranchWindow.items[0].departmentId = 0
      this.sendBranchWindow.items[0].departmentOfficeId = 0
      this.sendBranchWindow.items[0].selectObject = 0
    },
    // 查看关联业务信息
    queryTrustFrom() {
      if (this.job.relatedJob.trim().length > 0) {
        this.loading = getLoading4Cxt(this)
        if (this.job.fba) {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          fbaGetRelatedJob(this.job.relatedJob).then(res => this.queryTrustResultHandler(res)).finally(() => { this.closeLoading() })
        } else {
          // job相关的初始化也放在这里面了，统一返回，避免多次访问后端
          getTrustFromJob(this.job.relatedJob, 0).then(res => this.queryTrustResultHandler(res)).finally(() => { this.closeLoading() })
        }
      } else {
        this.$message.warning(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    async queryTrustResultHandler(event) {
      const trustJob = event.data
      if (trustJob) {
        // 显示关联业务
        this.trustFromWindow.trustJob = trustJob
        this.trustFromWindow.job = this.job
        this.trustFromWindow.visible = true
      } else {
        this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
      }
    },
    // 发送跨tenant
    doCrossTenantHandler() {
      this.$confirm(this.$t('Message.MakeSureToDelegateTheBusiness'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        // this.btnInfo.privilege.btnEntrustment = false
        this.sendCrossTenantHandler()
      }).catch(() => { })
    },
    // 发送跨tenant委托
    async sendCrossTenantHandler() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        // 检索订舱代理所属分公司在合作伙伴中维护的tenant，是否也维护了当前tenant
        mainTainCurrentTenantCompanies(company.relateTenantId, this.job.opOffice).then(res => this.maitainTenantResult(res))
      }
    },
    async maitainTenantResult(event) {
      const cmps = event.data
      if (cmps && cmps.length > 0) {
        this.partner = cmps[0]
        // 加载联系人
        await new Company(this.partner).getContacts()
        this.loadCrossTenantContractsHandler()
      } else {
        this.$message.warning(this.$t('Message.TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners'))
        // this.$refs.btnEntrustment.disabled = false
      }
    },
    loadCrossTenantContractsHandler() {
      queryLatestState(this.job.jobNo).then(res => this.stateResultHandler(res))
    },
    async stateResultHandler(event) {
      const latestState = event.data
      if (latestState === 3) {
        this.$message.warning(this.$t('Message.TheOppositeSideHasScceptedNoNeedToReCommission'))
      } else {
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const carrier = await Company.getCompanyById(this.job.carrierId)
        if (carrier) {
          if (!carrier.scac) {
            // this.btnInfo.privilege.btnEntrustment = true
            this.$message.warning(this.$t('Message.CheckCarrier', [carrier.chineseName]))
            return
          } else {
            getCompanyByTenantIdAndBranchIdAndScac(company.relateTenantId, company.relateTenantOfficeId, carrier.scac).then(res => this.hasCompanyResult(res))
          }
        } else {
          // 检验接收方是否维护对应的港口
          const codes = []
          if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
            codes.push(this.job.loadingPortCode)
          }
          if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
            codes.push(this.job.destinationPortCode)
          }
          if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
            codes.push(this.job.dischargingPortCode)
          }
          isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
        }
      }
    },
    async hasCompanyResult(event) {
      const hasCarrier = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!hasCarrier) { // bool 判断是否维护对应的船公司
        // this.btnInfo.privilege.btnEntrustment = true
        const sourceCarrier = await Company.getCompanyById(this.job.carrierId)
        this.$message.warning(this.$t('Message.CheckCompanyByConsignation').replace('{0}', company.chineseName).replace('{1}', sourceCarrier.chineseName))
        return
      } else {
        // 检验接收方是否维护对应的港口
        const codes = []
        if (this.job.loadingPortCode && !codes.includes(this.job.loadingPortCode)) {
          codes.push(this.job.loadingPortCode)
        }
        if (this.job.destinationPortCode && !codes.includes(this.job.destinationPortCode)) {
          codes.push(this.job.destinationPortCode)
        }
        if (this.job.dischargingPortCode && !codes.includes(this.job.dischargingPortCode)) {
          codes.push(this.job.dischargingPortCode)
        }
        isHavePorts(company.relateTenantId, codes).then(res => this.hasPortsResult(res))
      }
    },
    async hasPortsResult(event) {
      const result = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!result) {
        // 检验接收方是否维护对应的包装
        if (this.job.packing) {
          isHavePacking(company.relateTenantId, this.job.packing).then(res => this.hasPackingResult(res))
        } else {
          this.doSendCrossTenant()
        }
      } else {
        let message = ''
        for (const code of result) {
          const seaport = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', code)
          if (seaport) {
            message = message + seaport.englishName + ','
          }
        }
        if (message) {
          message = message.substring(0, message.length - 1)
        }
        // this.btnInfo.privilege.btnEntrustment = true
        const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', this.job.packing)
        this.$message.warning(this.$t('Message.CheckPackingByConsignation').replace('{0}', company.chineseName).replace('{1}', packing ? packing.name : ''))
        return
      }
    },
    // 查询是否被拒绝过
    async doSendCrossTenant() {
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (company) {
        isRejectedBySendJobNo(this.job.jobNo, company.relateTenantId).then(res => this.isRejectResult(res))
      }
    },
    isRejectResult(event) {
      const isReject = event.data
      if (isReject) { // bool 判断是否被拒绝过
        this.$confirm(this.$t('Message.ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          // 查询pdf模板
          queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
        }).catch(() => { })
      } else {
        // 查询pdf模板
        queryTemplateByNameAndType('BOOKING', this.$t('SeaExport.SeaExportLetter'), this.$store.getters.tenantId, this.office.officeId).then(res => this.templateSenderResultHandler(res))
      }
    },
    async templateSenderResultHandler(event) {
      this.template = event.data
      const company = await Company.getCompanyById(this.job.bookingAgent)
      if (!this.template) {
        this.$confirm(this.$t('Message.DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
        }).catch(() => {
          // this.btnInfo.privilege.btnEntrustment = true
        })
      } else {
        isCrossed(this.job.jobNo, company.relateTenantId).then(res => this.isCrossedHandler(res))
      }
    },
    isCrossedHandler(event) {
      const isCrossed = event.data
      this.enterSendCrossTenantHandler(isCrossed)
    },
    // isCrossed为false就说明没有委托过当前的订舱代理
    enterSendCrossTenantHandler(isCrossed) {
      const item = {}
      item.deptId = this.$store.getters.currentDeptId
      item.branchId = this.$store.getters.currentOfficeId
      item.anyStr = this.job.uuid
      item.anyBool = isCrossed
      item.anyBool1 = this.commonInfo.isCopySellingCharge // isCopySellingCharge
      item.anyInteger = this.partner.cmpIdx // cmpIdx
      item.location = this.location
      crossTenantJob(item).then(res => this.saveCrossTenantCloneResultHandler(res))
      if (this.sendBranchWindow.visible) {
        this.sendBranchWindow.visible = false
      }
    },
    async saveCrossTenantCloneResultHandler(res) {
      await this.mergeCurrentRow(res)
      this.$message.success(this.$t('Message.SuccessfullySent'))
    },
    async hasPackingResult(event) {
      const hasPacking = event.data
      if (!hasPacking) { // bool 判断是否有包装
        const company = await Company.getCompanyById(this.job.bookingAgent)
        const packing = getObjectByCache(basicCacheKeys.basic_data_Packing, 'code', this.job.packing)
        if (company && packing) {
          let msg = this.$t('SeaExport.CheckPackBeforeEntrust')
          msg = msg.replace('{0}', company.chineseName)
          msg = msg.replace('{1}', packing.name)
          this.$message.warning(msg)
        }
        return
      } else {
        this.doSendCrossTenant()
      }
    },
    // 日志记录
    logHandle() {
      if (!this.job || !this.job.uuid) {
        return
      }
      switch (this.logCommand) {
        case this.$t('SeaExport.DataPushChangeLog'):
          this.toQueryDataPushLog()
          break
        case this.$t('CargoMsg.Cargo_BusinessStatusChangeLog'):
          this.businessStatusDialog.visible = true
          break
        case this.$t('SeaExport.OperationLog'):
          this.dataUpdateLogDialog.visible = true
          this.dataUpdateLogDialog.isNeedExpand = true
          this.dataUpdateLogDialog.defaultIsExpand = true
          LocalStorageUtilsNew.setConfiguration('AEDataUpdateLogDialogVisible', true)
          break
      }
    },

    async toQueryDataPushLog() {
      this.context.loading = true
      await new AirExportJob(this.job).loadPushHistoryLogs()
      this.context.loading = false
      const item = this.job.pushHistoryLogs
      this.dataPushDialog.titles = []
      this.dataPushDialog.dataMap = new Map()
      if (item) {
        const dataArr = []
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k] })
        }
        // 排序 按时间降序
        sortByMultiField(dataArr, ['time'], true)
        if (dataArr && dataArr.length > 0) {
          for (const data of dataArr) {
            const logs = data.logs
            const firstLog = logs[0]
            let t = '：' + this.$t('SeaExport.DataPush')
            if (Number(firstLog.sourceType) === 1) {
              t = '：' + this.$t('SeaExport.MasterTicketSync')
            } else if (Number(firstLog.sourceType) === 2) {
              t = '：' + this.$t('queryJob.G7DataPush')
            }
            const labTime = new Date(Number(data.time))
            const title = DateUtils.formatStandardDateTime(labTime) + t
            this.dataPushDialog.titles.push(title)
            const cMap = {}
            let labLog = ''
            const titleVals = []
            for (const h of logs) {
              if (!cMap.hasOwnProperty(h.fieldName + h.targetValue)) {
                if (!h.sourceValue || h.targetValue === h.sourceValue) {
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_NewValue') + '->' + h.targetValue
                } else {
                  //
                  const newValArr = h.targetValue ? h.targetValue.split(' ') : []
                  labLog = h.fieldName + '：' + this.$t('CargoMsg.Cargo_OriginalValue') + '->' + h.sourceValue + ' ' + this.$t('CargoMsg.Cargo_NewValue') + '->' + (newValArr && newValArr.length > 0 ? newValArr[0] : '')
                  if (newValArr && newValArr.length > 0) {
                    for (const str of newValArr) {
                      const index = newValArr.indexOf(str)
                      if (index > 0) titleVals.push(str)
                    }
                  }
                }
                // 每一行便是一个div[ labLog -> div]
                titleVals.push(labLog)
              }
              if (h.fieldName === '箱种' || h.fieldName === '箱型') {
                cMap[h.fieldName + h.targetValue] = h.fieldName + h.targetValue
              }
            }
            this.dataPushDialog.dataMap.set(title, titleVals)
          }
        }
      }
      this.dataPushDialog.visible = true
    },
    goBack() {
      /* saveJobNos去重 */
      const map = new Map()
      for (const item of this.saveJobNos) {
        const newJob = {}
        for (const key in item) {
          if (typeof item[key] === 'object') {
            continue
          }
          newJob[key] = item[key]
        }
        delete newJob.isCompleteRow
        delete newJob.version
        map.set(item.uuid, newJob)
      }
      const saveJobNos = [...map.values()]
      this.$emit('back', saveJobNos, this.removedJobNos)
      setTimeout(() => {
        this.activeTabName = ''
      }, 500)
    },
    // 打印
    onPrint() {
      if (JobUtils.isBlockJob(this.job)) {
        this.$message.warning(this.job.jobNo + '已被锁定,不能打印,请联系上级主管解锁!')
        return
      }
      this.$nextTick(async() => {
        let params
        // 费用页签特殊弹窗回调打印处理
        if (this.activeTabName === 'tabCharges' && this.tabChargesPrintData) {
          params = this.tabChargesPrintData
          this.tabChargesPrintData = null
        }
        // 每个页签的参数
        params = params || await this.$refs[this.activeTabName].getPrintData() || null
        if (!params) return
        // 公共参数
        if (!Object.prototype.hasOwnProperty.call(params, 'jobuuid') || !params.jobuuid) {
          params.jobuuid = this.job.uuid
        }
        if (!Object.prototype.hasOwnProperty.call(params, 'JOB_UUID') || !params.JOB_UUID) {
          params.JOB_UUID = this.job.uuid
        }
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = Object.prototype.hasOwnProperty.call(params, 'ctx') ? params.ctx : null
        if (Object.prototype.hasOwnProperty(params, 'ctx')) delete params.ctx
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback(params)
        this.templateSelectorDialog.visible = true
      })
    },
    // 费用页签 多个结算公司选中单个后的打印回调
    tabChargesPrintDataCallBack(data) {
      if (data) {
        this.tabChargesPrintData = data
        this.onPrint()
      }
    },
    // 组装打印回调函数 优先取 params 里面的回调，再取页签中的回调，这样修改是为了满足国外账单的特殊情况
    onPrintCallback(params) {
      if (Object.prototype.hasOwnProperty.call(params, 'prePrintCallback')) {
        this.prePrintCallback = params.prePrintCallback
        delete params.prePrintCallback
      } else {
        this.prePrintCallback = this.$refs[this.activeTabName].prePrintCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'printedCallback')) {
        this.printedCallback = params.printedCallback
        delete params.printedCallback
      } else {
        this.printedCallback = this.$refs[this.activeTabName].printedCallback || null
      }
      if (Object.prototype.hasOwnProperty.call(params, 'v2CheckCallback')) {
        this.v2CheckCallback = params.v2CheckCallback
        delete params.v2CheckCallback
      } else {
        this.v2CheckCallback = this.$refs[this.activeTabName].v2CheckCallback || null
      }
    },
    // 利润分析打印
    async profitPrintHandler() {
      this.commonInfo.isPrint = true
      this.optName = '利润分析打印'
      this.commonInfo.isPrintOpr = true
      // 打印利润分析表后是否变更业务状态 0:不变更，1:变为预提交，2:变为已提交
      this.commonInfo.isPreCommit = Number(this.config.get('PrintProfitToPreCommit')) === 1
      // 判断是否开启验证规则
      const checkNode = CheckRuleConstants.NODE_PRINT_PROFIT.code
      const useCheckRule = Number(this.config.get('useCheckRule')) === 1
      // const hasCheckRule = await JobUtils.hasCheckRuleCondition(useCheckRule, checkNode, this.job.opOffice)
      const hasCheckRule = true
      if (useCheckRule && hasCheckRule) {
        const callBack = this.getPrePrintProfit
        this.checkingManager(checkNode, callBack, null)
      } else {
        const checkApChargeVerify = Number(this.config.get('PreCommitJobCheckApChargeStateVerify'))
        if (this.commonInfo.isPreCommit && checkApChargeVerify === 1) {
          const isPass = await JobUtils.checkChargeStateVerify(this.job)
          if (!isPass) {
            this.$message.warning(this.$t('Message.NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance'))
            return
          }
        }
        this.getPrePrintProfit()
      }
    },

    getPrePrintProfit() {
      // 当是利润打印按钮事件且 PrintProfitToPreCommit=2 时，先打印再提交
      if ([1, 2].includes(Number(this.config.get('PrintProfitToPreCommit')))) {
        this.prePintProfitResultHandler({ data: this.job })
      } else {
        calculateProfit(this.job.uuid, -1, this.commonInfo.isPrint, true, this.commonInfo.isPreCommit, this.office.officeId, '', this.location).then(res => this.prePintProfitResultHandler(res))
      }
    },
    prePintProfitResultHandler(res) {
      const category = this.job.operateType === AirExportConstants.CONSOLE.code ? 'AEPROFIT2' : 'AEPROFIT'
      this.prePintProfit(res, category)
    },
    // 利润打印
    async prePintProfit(res = {}, type) {
      // await this.mergeCurrentRow(res)
      this.$nextTick(() => {
        const params = {}
        params.jobuuid = this.job.uuid
        params.showPreview = this.commonInfo.isPrint
        params.isPreCommit = this.commonInfo.isPreCommit
        params.JOB_UUID = this.job.uuid
        this.templateSelectorDialog.ctx = new AirExportJob(this.job)
        this.templateSelectorDialog.category = type
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        this.prePrintCallback = null
        this.printedCallback = this.prePrintProfitCallBack
        this.v2CheckCallback = this.doPrintPROFIT_V2
        this.templateSelectorDialog.visible = true
      })
      this.updateControlsState()
      this.refresh()
    },
    prePrintProfitCallBack(event) {
      this.commonInfo.printEvent = event
      this.commonInfo.isPrintCommit = event.isPreCommit
      if (PrintUtils.isExecutor(event.action) && this.job && this.job.uuid) {
        this.printAlert(true)
      }
    },
    refChargeChargeState(charges) {
      const submitChargeState = parseInt(this.config.get('CommitJobChangedChargeState'))
      if (submitChargeState === 1 && charges && charges.length > 0) {
        for (const c of charges) {
          if (c.chargeState === BillingConstants.CHARGE_STATE_SUBMIT.code) {
            c.chargeState = BillingConstants.CHARGE_STATE_NORMAL.code
          }
        }
      }
    },
    // 合并当前job【刷新当前job】
    async mergeCurrentRow(res) {
      if (res && res.data) {
        for (const key in res.data) {
          if (typeof this.currentRow[key] === 'object') {
            continue
          }
          this.currentRow[key] = res.data[key]
        }
        const ajaxResults = []
        if (this.currentRow.masterFlag) {
          this.currentRow.lclSlaves = ''
          ajaxResults.push(new AirExportJob(this.currentRow).getLclSlaves())
        }
        this.currentRow.charges = ''
        ajaxResults.push(new AirExportJob(this.currentRow).getCharges())
        await Promise.all(ajaxResults)
        // Object.assign(this.currentRow, res.data)
        this.currentRow.uuid = res.data.uuid
        this.currentRow.isCompleteRow = false
        this.saveJobNos.push(this.currentRow)
        this.isRefresh = true
      }
    },
    // 退回操作,撤回
    async backReturn() {
      if (this.job.jobState === SystemConstants.COMMITED || this.job.jobState === SystemConstants.PRE_COMMIT) {
        this.commonInfo.operateNameCode = SystemConstants.OPERATE_PRINT_RETURN.code
        let lb = this.$t('Message.Withdraw')
        if (this.job.jobState === SystemConstants.PRE_COMMIT) {
          this.commonInfo.operateNameCode = SystemConstants.OPERATE_RETURN_ACTION.code
          lb = this.$t('Message.ReturnAction')
        }
        const operate = this.job.jobState === SystemConstants.PRE_COMMIT ? SystemConstants.OPERATE_RETURN_ACTION.code : SystemConstants.OPERATE_PRINT_RETURN.code
        if (!await JobUtils.backCheckJobState([this.job.uuid], operate, this.job)) {
          this.refresh()
          return
        }
        this.$confirm(this.$t('Message.IsConfirm') + lb + '?', this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(async() => {
          this.loading = getLoading()
          backReturn({ jobUuids: [this.job.uuid], lob: 'AE', location: this.location }).then(async res => {
            this.loading.close()
            if (Number(this.config.get('CommitOpenAutoPushJobToCBMS')) === 1 &&
              this.commonInfo.operateNameCode === SystemConstants.OPERATE_PRINT_RETURN.code) {
              await this.commitCBMSResultHandler(res, '1')
            } else if (this.commonInfo.openHecConfig) {
              this.backReturnSapResultHandler(res)
            } else {
              await this.mergeCurrentRow(res)
              this.refresh()
            }
            if (this.currentRow.masterFlag) {
              this.currentRow.lclSlaves = ''
              await new AirExportJob(this.currentRow).getLclSlaves()
            }
            this.$message.success(this.$t('Message.AlreadyWithdraw'))
          }).finally(() => {
            this.loading.close()
          })
          // await this.onConfirmedPrintReturn()
          this.refreshLeftTree()
        }).catch(() => { })
      }
    },
    onConfirmedPrintReturn() {
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code) {
        this.loadLclSlavesHandler()
      } else {
        this.loadChargesPrintReturnHandler()
      }
    },
    async loadLclSlavesHandler() {
      await new AirExportJob(this.job).getCharges()
      const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
      if (lclSlaves) {
        for (const sej of lclSlaves) {
          if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
            await new AirExportJob(sej).getCharges()
          }
        }
      }
      this.loadJobsChargesPrintReturnHandler()
    },
    async loadJobsChargesPrintReturnHandler() {
      this.job.jobState = SystemConstants.OPERATING
      this.job.submissionDate = null
      this.refChargeChargeState(this.job.charges)
      for (const sej of this.job.lclSlaves) {
        if (sej.jobState === SystemConstants.COMMITED || sej.jobState === SystemConstants.PRE_COMMIT) {
          this.refChargeChargeState(sej.charges)
        }
        sej.jobState = SystemConstants.OPERATING
        sej.submissionDate = null
        sej.operateNameCode = this.commonInfo.operateNameCode
      }
      this.job.operateNameCode = this.commonInfo.operateNameCode
      this.resetNoNeedSaveData()
      await saveJobInfo(this.job).then(async res => {
        await this.mergeCurrentRow(res)
        this.refresh()
        this.$message.success(this.$t('Message.AlreadyWithdraw'))
      })
    },
    // 提交改单费用
    changeCommit_clickHandler() {
      this.$confirm(this.$t('SeaExport.ConfirmChangeCommit'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        updateChangeState(Array.of(this.job.uuid), { changeState: SystemConstants.CHANGE_COMMIT.code, location: this.location }).then(res => this.updateChangeStateHandler(res))
      }).catch(() => { })
    },
    updateChangeStateHandler(res) {
      this.commitResultHandler({ data: res.data[0] })
    },
    // 根据对象的属性排序[descending 是否降序]
    createComparisonFunction(propertyName, descending = false) {
      return function(object1, object2) {
        const value1 = object1[propertyName]
        const value2 = object2[propertyName]

        if (!descending) {
          return value1 - value2
        } else {
          return value2 - value1
        }
      }
    },
    // 验证规则配置公用
    async checkingManager(checkNode, callBack, callBack2) {
      if (!this.job) return
      let checkType = true
      if (this.job.masterFlag && checkNode !== CheckRuleConstants.NODE_SAVE_BUSINESS.code) {
        checkType = false
        this.batchCheckingWindow.checkNode = checkNode
        this.batchCheckingWindow.callBack = callBack
        this.batchCheckingWindow.callBack2 = callBack2

        const lclSlaves = await new AirExportJob(this.job).getLclSlaves()
        if (lclSlaves && lclSlaves.length > 0) { // 批量验证
          this.batchCheckingWindow.jobs = [this.job, ... lclSlaves]
        } else {
          this.batchCheckingWindow.jobs = [this.job]
        }
        this.batchCheckingWindow.visible = true
      }
      if (checkType) { // 单个验证
        this.checkingWindow.checkNode = checkNode
        this.checkingWindow.callBack = callBack
        this.checkingWindow.callBack2 = callBack2
        this.checkingWindow.visible = true
      }
    },
    async addBatchLcl(lclJob) {
      lclJob.path = ''
      await this.onShow('add', this.rowData, lclJob)
      lclJob.customerRefNo = ''
    },
    transferTargetRow(action, jobUuid) {
      const selectedRow = this.rowData.find(p => p.uuid === jobUuid)
      if (selectedRow) {
        this.onShow(action, this.rowData, selectedRow)
      }
    },
    addSlavedJob(jobs) {
      const addSlaveJobs = []
      for (const job of jobs) {
        // 更新 存在于左侧list加入的job
        const findLeftJob = this.rowData.find(p => p.uuid === job.uuid)
        if (findLeftJob) {
          findLeftJob.parentUuid = job.lclMasterUuid
          findLeftJob.path = job.lclMasterUuid + ',' + job.uuid
          findLeftJob.dataType = 2 // 小票
        } else {
          job.jobUuid = job.uuid
          job.parentUuid = job.lclMasterUuid
          job.path = job.lclMasterUuid + ',' + job.uuid
          job.dataType = 2 // 小票
          addSlaveJobs.push(job)
        }
      }
      this.rowData = [...this.rowData, ...addSlaveJobs]
      this.saveJobNos.push(this.currentRow)
      this.saveJobNos.push(...jobs)
      for (let i = this.removedJobNos.length - 1; i >= 0; --i) {
        if (jobs.findIndex(p => p.uuid === this.removedJobNos[i].uuid) >= 0) {
          this.removedJobNos.splice(i, 1)
        }
      }

      this.gridApi.refreshCells({ force: true })

      // 当前主票的件重尺也需要更新 重新加载
      this.currentRow.isCompleteRow = false
      this.currentRow.version = 0
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object' && key !== 'lclSlaves') {
          this.currentRow[key] = ''
        }
      }
      this.againShow('look')
    },
    removeJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => !jobKeys.includes(p.uuid))
      const removedRows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      // for (const row of rows) {
      //   row.lclMasterUuid = ''
      //   row.mbl = ''
      //   row.parentUuid = ''
      //   row.path = row.uuid
      //   row.isCompleteRow = false
      // }
      this.rowData = [...rows]
      this.saveJobNos.push(this.currentRow)
      this.removedJobNos.push(...removedRows)

      // 当前主票的件重尺也需要更新 重新加载
      this.currentRow.isCompleteRow = false
      this.currentRow.version = 0
      // 重置子表数据
      for (const key in this.currentRow) {
        if (typeof this.currentRow[key] === 'object') {
          this.currentRow[key] = ''
        }
      }
      this.againShow('look')
    },
    removeJob(jobUuids) {
      for (let i = 0; i < this.rowData.length; i++) {
        let index = -1
        for (const key of jobUuids) {
          if (key && this.rowData[i] === key) {
            index = i
            break
          }
        }
        if (index > -1) {
          this.rowData.splice(index, 1)
          this.removedJobNos.push(this.rowData[index])
        }
      }
      this.saveJobNos.push(this.currentRow)
    },
    splitHandle(row) {
      this.view = 'detail'
      this.onShow('split', this.rowData, row)
    },
    // form表单请求方法
    navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    resetTab(tabName) {
      this.pendTabSet.delete(tabName)
    },
    syncData(data) {
      Object.assign(this.currentRow, data)
    },
    globalUploadEnd() {
      if (this.activeTabName !== 'tabFileHistory') {
        this.activeTabName = 'tabFileHistory'
      }
      if (!Array.from(this.pendTabSet).includes('tabFileHistory')) {
        this.handleTabClick()
      } else {
        this.$refs.tabFileHistory.onShow(this.paramsOfTab, true)
      }
    },
    goBackForDeleteJob() {
      this.activeTabName = ''
      this.$emit('back', true)
    },
    generalMChargeWeightHandler() {
      if (this.$refs.tabMAWB) {
        this.$refs.tabMAWB.totalChargeHandler()
      }
    },
    generalHChargeWeightHandler() {
      if (this.$refs.tabHAWB) {
        this.$refs.tabHAWB.cWeightChangeHandler()
      }
    },
    // 主单号点击分离，主票小票关系断开
    detchJobFromMaster(jobKeys) {
      const rows = this.rowData.filter(p => jobKeys.includes(p.uuid))
      for (const row of rows) {
        row.lclMasterUuid = ''
        row.mbl = ''
        row.parentUuid = ''
        row.path = row.uuid
        row.isCompleteRow = false
      }
      this.rowData = [...this.rowData]
    },
    // 改变操作模式时数据的变化
    changeOperateType(data) {
      switch (data.oldOperateType) {
        case AirExportConstants.CONSOLE.code :
          this.detchJobFromMaster([data.job.uuid])
          break
        case AirExportConstants.DIRECT.code :
        case AirExportConstants.BACK_TO_BACK.code :
          if (data.job.operateType === AirExportConstants.CONSOLE.code) {
            // 一主一分切换到一主多分，如果有主单号，那么自动生成主票
            if (data.job.lclMaster) {
              data.job.lclMaster.path = data.job.lclMaster.uuid
              data.job.lclMaster.isCompleteRow = false
              data.job.lclMaster.parentUuid = data.job.lclMaster.uuid
              data.job.lclMaster.isCompleteRow = false
              this.rowData.push(data.job.lclMaster)
              const rows = this.rowData.filter(p => p.uuid === data.job.uuid)
              for (const row of rows) {
                row.path = data.job.lclMasterUuid + ',' + data.job.uuid
                row.parentUuid = data.job.lclMasterUuid
                row.isCompleteRow = false
              }
            }
          }
          break
        default :
          break
      }
    },
    async updateJob() {
      const data = {}
      for (const key in this.paramsOfTab) {
        if (typeof this.paramsOfTab[key] === 'object') {
          continue
        }
        data[key] = this.paramsOfTab[key]
      }
      const loading = getLoading4Cxt(this)
      const res = await saveJobInfo(data).finally(() => {
        loading.close()
      })
      this.mergeCurrentRow(res)
      this.refresh()
    },
    async continueSaving(body, loading, closingLoading = false) {
      try {
        if (closingLoading) {
          loading = getLoading4Cxt(this)
        }
        // 保存 访问数据库
        const oldBusinessDate = this.currentRow.etd
        const businessDate = this.paramsOfTab.etd
        const charges = this.paramsOfTab.charges
        body.location = this.location
        body.receiptCharges = this.context.receiptCharges
        let blockCreditData = null
        await this.saveAeBookingSpaceFunc(body).then(res => {
          if (res.data && res.data.job) {
            Object.assign(this.currentRow, res.data.job)
            this.currentRow.uuid = res.data.job.uuid
            this.currentRow.jobUuid = this.currentRow.uuid
            body.job.uuid = this.currentRow.jobUuid
            this.currentRow.version = 0 // 标识为脏数据，需要重新载入
            this.isRefresh = true
            this.saveJobNos.push(this.currentRow)
          }
          // 重置子表数据
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
          this.currentRow.isCompleteRow = false
          blockCreditData = res.data.blockCreditData
        })
        this.refreshLeftTree()

        // 复制多份业务 保存的处理逻辑
        if (this.copyJobNum > 1 && this.currentRow.uuid) {
          await this.saveCopyJobHandle(this.currentRow.uuid, this.copyJobNum - 1, this.currentRow.masterFlag)
        }
        // 主票页签新增多个小票，保存的处理逻辑(海进之后新增一个小票)
        if (this.currentRow.lclNumber && this.currentRow.uuid) {
          const job = this.currentRow
          // 更新新增的第一条小票数据
          await new AirExportJob(job).loadJobRelated({ job: true })
          job.jobUuid = job.uuid
          job.parentUuid = job.lclMasterUuid
          job.path = job.lclMasterUuid + ',' + job.uuid
          job.dateType = 2 // 小票
          if (job.lclNumber > 1) {
            await this.saveLclJob(job.uuid, job.lclNumber - 1)
          }
          delete job.lclNumber
          // 切换回主票
          this.currentRow = this.rowData.find(p => p.uuid === job.lclMasterUuid)
          this.currentRow.version = 0
          // 重置子表数据【将job相关信息置空，然后从库里重新加载】
          for (const key in this.currentRow) {
            if (typeof this.currentRow[key] === 'object') {
              this.currentRow[key] = ''
            }
          }
        }
        for (const item of this.pendTabSet) {
          const executeTask = this.$refs[item].executeTask
          if (executeTask && typeof executeTask === 'function') {
            /* 保存成功后的回调 */
            const result = this.$refs[item].executeTask()
            if (result instanceof Promise) {
              await result
            }
          }
        }
        this.againShow('look')
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        /*        if (this.currentRow.jobState === 0 && businessDate !== oldBusinessDate && ChargeUtils.ChargeUtils.exchangeRateNeedUpdate(charges, businessDate)) {
          setTimeout(() => {
            this.$message.success(this.$t('queryJob.BusinessDateChangedUpdateExchangeRate'))
          }, 100)
        }*/
        this.copyJobNum = 0
        // 保存业务触发SOP后需要刷新 SOP操作状态弹框
        if (this.sopStateDialog.visible) {
          setTimeout(() => {
            this.sopStateDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存业务后需要刷新 变更日志记录弹框
        if (this.dataUpdateLogDialog.visible) {
          setTimeout(() => {
            this.dataUpdateLogDialog.isNeedRefresh = true
          }, 3000)
        }
        // 保存成功后触发
        if (Reflect.has(body, 'job')) {
          this.saveResultHandler(body.job)
          // 将rowData放到列表中
          this.$emit('synchronizeRowData', this.rowData)
        }
        JobUtils.handleCreditRemind(this.currentRow, blockCreditData)
      } catch (err) {
        throw err
      } finally {
        if (closingLoading) {
          loading.close()
        }
      }
    },
    async saveAeBookingSpaceFunc(body) {
      // 数据已被其他人修改
      let dataModified = false
      let userName = ''
      let modifyDate = ''
      let err = null
      try {
        return await saveAeBookingSpace(body, true, true)
      } catch (res) {
        let error17 = null
        if (res.errors) {
          error17 = res.errors.find(p => p.code === '0017')
        }
        if (error17) {
          dataModified = true
          const start = error17.message.indexOf('[')
          if (start > -1) {
            const end = error17.message.indexOf(']', start)
            if (end > -1) {
              userName = error17.message.substring(start + 1, end)
            }
          }
          const match = error17.message.match(/[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}/)
          modifyDate = match[0] || ''
          err = res
        } else {
          this.$message({
            showClose: true,
            message: res.errorMsg,
            dangerouslyUseHTMLString: res.errorMsg && res.errorMsg.indexOf('<br/>') > -1,
            type: 'error',
            duration: 5 * 1000
          })
          throw res
        }
      }
      if (dataModified) {
        const oldData = lodash.cloneDeep(this.currentRow) // 旧版本的数据
        const editOldData = lodash.cloneDeep(this.paramsOfTab) // 正在编辑的旧版本的数据
        const pendTabs = [...this.pendTabSet]
        const modifiedData = { ...this.context.modifiedData }
        this.currentRow.version = 0
        for (const key in this.currentRow) {
          if (typeof this.currentRow[key] === 'object') {
            this.currentRow[key] = ''
          }
        }
        this.currentRow.isCompleteRow = false
        await this.onRowClicked({ data: this.currentRow, skipTabHandle: true })
        if (pendTabs.includes('tabTradeDetail')) {
          await new AirExportJob(this.currentRow).getPoItems()
        }
        if (pendTabs.includes('tabTradeCommission')) {
          await new AirExportJob(this.currentRow).getPoList()
        }
        if (pendTabs.includes('tabUsCustomsClearance')) {
          await this.$refs['tabUsCustomsClearance'].onShow(this.paramsOfTab, true)
        }
        if (pendTabs.includes('tabUsCustomsClearanceMaster')) {
          await this.$refs['tabUsCustomsClearanceMaster'].onShow(this.paramsOfTab, true)
        }
        const newData = this.currentRow // 最新版本的数据
        this.paramsOfTab = JobUtils.compareAndMergeJobData(oldData, editOldData, newData)
        this.pendTabSet.clear()
        for (const pendTab of pendTabs) {
          this.pendTabSet.add(pendTab)
          if (pendTab === 'tabCharges') {
            this.showBasicInfoWindow()
          }
          this.$refs[pendTab].onShow(this.paramsOfTab, true)
        }
        const filedMap = new Map([['dischargingTruckingInfo', 'dischargingTrucking'], ['truckingInfo', 'trucking']])
        for (const key in modifiedData) {
          const sourceKey = filedMap.get(key) || key
          if (modifiedData[key] instanceof Array && this.paramsOfTab[sourceKey] instanceof Array) {
            const targetArray = modifiedData[key]
            const souceArray = this.paramsOfTab[sourceKey]
            for (let i = 0; i < targetArray.length; ++i) {
              const sourceItem = souceArray.find(p => p === targetArray[i] || (p.uuid && p.uuid === targetArray[i].uuid))
              if (sourceItem) {
                targetArray[i] = sourceItem
              }
            }
            this.context.modifiedData[key] = modifiedData[key]
          }
        }
        const flag = await this.$confirm(this.$t('queryJob.DataModifiedHasMergeContinueSave', [userName, modifyDate]), this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('Message.Yes'),
          cancelButtonText: this.$t('Message.No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => true).catch(() => false)
        if (flag) {
          const newBody = {}
          if (body.job) {
            newBody.job = { ...this.paramsOfTab }
            // 还原接单分公司
            if (this.useOrderCenterMode) {
              if (newBody.job.cooperate && newBody.job.cooperate.uuid) {
                newBody.job.opOffice = newBody.job.opOffice_original || newBody.job.opOffice // 分公司
                newBody.job.op = newBody.job.op_original || newBody.job.op // 操作
                newBody.job.csr = newBody.job.csr_original || newBody.job.csr // 客服
                newBody.job.overseaOp = newBody.job.overseaOp_original || newBody.job.overseaOp // 海外操作
                newBody.job.dc = newBody.job.dc_original || newBody.job.dc // 单证
                newBody.job.planner = newBody.job.planner_original || newBody.job.planner // 航线负责人
                newBody.job.opDepartment = newBody.job.opDepartment_original || newBody.job.opDepartment // 操作部门
                JobUtils.restoreJobFromCooperateInfo(newBody.job)
              }
            }
            for (const key in newBody.job) {
              if (newBody.job[key] instanceof Object) {
                newBody.job[key] = ''
              }
            }
          }
          for (const key in body) {
            if (key === 'job') {
              continue
            }
            const sourceKey = filedMap.get(key) || key
            if (body[key] instanceof Array) {
              if (this.paramsOfTab[sourceKey] instanceof Array) {
                const uuids = []
                newBody[key] = []
                for (const bodyItem of body[key]) {
                  if (bodyItem.uuid) {
                    uuids.push(bodyItem.uuid)
                  } else {
                    newBody[key].push(bodyItem)
                  }
                }
                for (const mergeItem of this.paramsOfTab[sourceKey]) {
                  if (uuids.includes(mergeItem.uuid)) {
                    newBody[key].push(mergeItem)
                  }
                }
              } else {
                newBody[key] = body[key]
              }
            } else if (body[key] instanceof Object) {
              newBody[key] = this.paramsOfTab[sourceKey] || body[key]
            } else {
              newBody[key] = body[key]
            }
          }
          this.cleanCircleObject(newBody)
          return await saveAeBookingSpace(newBody, true)
        } else {
          throw err
        }
      }
    },
    syncInfoHandle() {
      switch (this.syncInfoCommand) {
        case this.$t('SeaExport.AssociationBusinessInformationSI'):
          this.entrustmentSIClickHandler()
          break
        case this.$t('SeaExport.SynchronizationInformation'):
          this.syncExportToImportRelatedJob()
          break
      }
    },
    // 同步信息-出口同步到进口【租户内】
    async syncExportToImportRelatedJob() {
      if (this.job.relatedJob) {
        const loading = getLoading4Cxt()
        const company = await Company.getCompanyById(this.job.destinationAgent)
        const anyBool = (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) // 内部委托
        const anyBool1 = (company && company.relateTenantId > 0 && company.overseaAgent) // 跨租户委托
        syncRelatedJob({ anyStr: this.job.uuid, anyStr1: this.job.relatedJob, anyBool: anyBool, anyBool1: anyBool1 }).then(res => {
          this.$message.success(this.$t('queryJob.SuccessSyncInfo'))
        }).finally(() => {
          loading.close()
        })
      } else {
        this.$message.info(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    // 出口转进口
    async entrustmentSIClickHandler() {
      if (this.btnInfo.label.btnEntrustmentAI === this.$t('SeaExport.AssociationBusinessInformationSI') && this.job.relatedJob) {
        // 查看关联进口业务信息
        if (this.job.relatedJob.trim().length > 0) {
          getRelatedAiJob(this.job.relatedJob).then(res => {
            if (res.data) {
              this.relatedAiFromWindow.relatedJob = res.data
              this.relatedAiFromWindow.visible = true
            } else {
              this.$message.warning(this.$t('Message.FailedToQueryTheAssociatedBusiness'))
            }
          })
        } else {
          this.$message.info(this.$t('Message.NoAssociatedBusiness'))
        }
        return
      }
      this.enableEntrustmentAI = true
      const company = await Company.getCompanyById(this.job.destinationAgent)
      this.$logger.log('company- company', company)
      if (company && company.linkedBranchId > 0 && company.linkedBranchId !== this.job.opOffice) { // 内部委托
        if (this.btnInfo.label.btnEntrustment === this.$t('SeaExport.ConsignationSI')) {
          if (this.job.relatedJob) {
            this.$message.info(this.$t('Message.TicketEntrustedCannotRepetitionDelegate'))
            return
          }
        }
        this.doSendBranchHandler()
      }
    },
    // 交差委托，双向同步【租户内】
    syncRelatedJob() {
      if (this.job.relatedJob || this.job.trustFromJob) {
        this.loading = getLoading4Cxt()
        syncRelatedJobFunc({ anyStr: this.job.uuid }).then(res => {
          if (res.data) {
            if (res.data.success) {
              this.$message.success(this.$t('Message.SynchronizationSucceeded'))
            } else if (res.data.message === 'jobStateError') {
              this.$message.warning(this.$t('Message.ThisJobIsNotWorkingCanNotBeEdited2'))
            } else {
              this.$message.warning(this.$t('Message.SynchronizationFail'))
            }
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.$message.info(this.$t('Message.NoAssociatedBusiness'))
      }
    },
    // 发送分公司
    doSendBranchHandler() {
      if (this.enableEntrustmentAI) {
        if (this.btnInfo.label.btnEntrustmentAI === this.$t('SeaExport.AssociationBusinessInformationSI')) {
          // TrustFromWindow 目前只有海出
          this.$message.info(this.$t('SeaExport.ShowAssociationBusinessInformationSI'))
        } else {
          this.checkingConsignationJob()
        }
      }
    },
    /**
     * 锁定买价或卖价
     *
     * @param type 类型
     * @param lock 锁定
     */
    updatePriceLock_clickHandler(type, lock) {
      if (lock) {
        this.$confirm(type ? this.$t('CargoMsg.Cargo_ConfirmLockLabelBuyingPrice') : this.$t('CargoMsg.Cargo_ConfirmLockLabelSellingPrice'), this.$t('Message.Confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          this.doUpdatePriceLockFunc(lock, type)
        })
        return
      }
      this.doUpdatePriceLockFunc(lock, type)
    },
    doUpdatePriceLockFunc(lock, type) {
      const loading = getLoading4Cxt(this)
      const data = {
        jobUuid: this.job.uuid,
        type: type,
        lock: lock
      }
      updatePriceLockFunc(data).then(res => {
        if (res.data) {
          if (type) {
            this.job.purchasePriceLock = lock
          } else {
            this.job.sellingPriceLock = lock
          }
          this.$message.success(this.$t('CargoMsg.Cargo_LockSuccess', [(lock ? this.$t('CargoMsg.Cargo_LockLabel') : this.$t('CargoMsg.Cargo_UnLockLabel')),
            (type ? this.$t('CargoMsg.Cargo_BuyingPrice') : this.$t('CargoMsg.Cargo_SellingPrice'))]))
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_UpdateFailed'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 后端检查该业务是否可以委托
    checkingConsignationJob() {
      checkingConsignationJob(this.job.uuid).then(res => this.sendAIBranchHandler(res))
    },
    // 发送分公司
    async sendAIBranchHandler(event) {
      if (event.data === 1) {
        const company = await Company.getCompanyById(this.enableEntrustmentAI ? this.job.destinationAgent : this.job.bookingAgent)
        if (company) {
          // 检索属于订舱代理所属分公司的合作伙伴ID
          queryCompany(1, this.job.opOffice).then(res => this.queryCompanyResultHandler(res))
        }
      } else {
        this.$message.info(this.$t('Message.CheckingConsignation'))
      }
    },
    // 客服change事件
    async userIdAI_changeHandler(item) {
      const userId = item.userId
      if (userId > 0) {
        if (item.selectObject === 0) {
          await getUserDefaultDepartment({
            category: 'role',
            shape: 'csr',
            userId: userId
          }).then(res => this.getDefaultCsrResult(res, item))
        } else {
          const office = this.sendBranchWindow.office
          if (office) {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId,
              officeId: office.officeId
            }).then(res => this.getDefaultDeptResult(res, item))
          } else {
            await getUserDefaultDepartment({
              category: 'role',
              shape: 'op',
              userId: userId
            }).then(res => this.getDefaultDeptResult(res, item))
          }
        }
      } else {
        item.departmentId = 0
        item.userId = 0
      }
    },
    // 操作部门
    getDefaultDeptResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
      } else {
        item.departmentId = 0
      }
    },
    // 客服部门
    async getDefaultCsrResult(event, item) {
      const dep = event.data
      if (dep) {
        item.departmentId = dep.departmentId
        if (dep.officeUuid) {
          await getOfficeByUuid(dep.officeUuid).then(res => this.officeLoadHandler(res, item))
        } else {
          this.officeLoadHandler({ data: dep.office }, item)
        }
      } else {
        item.departmentId = 0
        item.departmentOfficeId = 0
      }
    },
    // 加载csr加载dep后加载office后更新业务的客服分公司
    officeLoadHandler(event, item) {
      const office = event.data
      if (office) {
        item.departmentOfficeId = office.officeId
      } else {
        item.departmentOfficeId = 0
      }
    },
    // 协作
    cooperationHandler() {
      this.cooperationBranchListDialog.jobUuid = this.job.uuid
      this.cooperationBranchListDialog.job = this.job
      this.cooperationBranchListDialog.orderCenterBranch = this.orderCenterBranch
      this.cooperationBranchListDialog.visible = true
    },
    // 退回
    cooperationReturnHandler() {
      this.$confirm(this.$t('CargoMsg.Cargo_AreYouSureReturn'), this.$t('CargoMsg.Cargo_Tips'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.toCooperationReturn()
      }).catch(() => {
        //
      })
    },
    toCooperationReturn() {
      const loading = getLoading4Cxt(this)
      updateState({ jobUuid: this.job.uuid, branchId: this.$store.getters.currentOffice.officeId, statusType: SystemConstants.STATUSTYPE_COOPERATE.code, status: SystemConstants.COOPERATE_STATUS_RETURNED.code }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReturnedSuccess'))
      }).finally(() => {
        loading.close()
      })
    },
    // CARGO-30747 空运出口，在基本页面收发通输入内容后，可以同步到HAWB页面
    syncDocSft(doc, shipper, consignee, notify) {
      if (!doc || !doc.docType) return
      if (this.$refs.tabMAWB && doc.docType === 'MAWB') {
        this.$refs.tabMAWB.syncDocSft(doc, shipper, consignee, notify)
      }
      if (this.$refs.tabHAWB && doc.docType === 'HAWB') {
        this.$refs.tabHAWB.syncDocSft(doc, shipper, consignee, notify)
      }
    },
    // im入口值返回
    async getImGroupFunc(paramsOfTab) {
      const result = paramsOfTab.data
      if (!this.imCacheKey || !result || (result && !result.jobNo)) {
        return
      }
      let etdTime = ''
      if (result && result.etd) {
        etdTime = result.etd.slice(0, 10)
      } else {
        etdTime = ''
      }
      const imGroupName = `${result.jobNo}-${etdTime}-${ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', result.dischargingPortCode, 'englishName')}`
      const userInfo = this.$store.getters.userInfo
      // 销售 揽货销售 海外客服 航线负责人 现场操作 单证 自定义岗位1 自定义岗位2
      const personnel = ['sales', 'cargoSalesId', 'overseaOp', 'planner', 'siteOP', 'dc', 'csr', 'userDefinedRoleId1', 'userDefinedRoleId2', 'op']
      const data = {
        tenantId: userInfo.tenantId,
        cargowareCompanyId: result.customerId, // cargoware的合作伙伴，对应b2b的订舱公司
        loginUserId: userInfo.userId,	// 登陆人userId
        customerEmail: result.contactEmail, // 客户邮箱
        otherUserIdList: [userInfo.userId], // 其他内部人userId，userName
        docId: result.jobNo, // 单据Id
        type: '' // 单据type
      }
      if (!data.customerEmail) {
        await this.loadCustomer(data, result)
      }
      for (const item of personnel) {
        if (result[item]) {
          data.otherUserIdList.push(result[item])
        }
      }
      this.$refs.cargoIm.onShow(data, imGroupName)
    },
    async loadCustomer(data, result) {
      console.log('result.customerId======', result)
      let company = { cmpIdx: result.customerId }
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts) {
        for (const contact of contacts) {
          if (contact.contactPerson === result.customerContact) {
            data.customerEmail = contact.email
            break
          }
        }
      }
    },
    // 审批发起回调
    applyCloseAndRefresh() {
      this.jobApplyDialog.visible = false
      this.currentRow.version = 0
      this.refresh()
    },
    onCheckConsigneeDefaultChange() {
      LocalStorageUtilsNew.setConfiguration('AE_checkConsigneeDefault', this.sendBranchWindow.checkConsigneeDefault)
      if (this.sendBranchWindow.checkConsigneeDefault) {
        this.onConsigneeTargetChange()
        this.onConsigneeDetailTargetChange()
      } else {
        LocalStorageUtilsNew.removeConfiguration('AE_consigneeTargett')
        LocalStorageUtilsNew.removeConfiguration('AE_consigneeDetailTarget')
      }
    },
    onConsigneeTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('AE_consigneeTargett', this.sendBranchWindow.consigneeTarget)
      }
    },
    onConsigneeDetailTargetChange() {
      if (this.sendBranchWindow.checkConsigneeDefault) {
        LocalStorageUtilsNew.setConfiguration('AE_consigneeDetailTarget', this.sendBranchWindow.consigneeDetailTarget)
      }
    },
    mactchCooperateBranch(cooperateBranch, office) {
      if (cooperateBranch && office) {
        const list = cooperateBranch.split(' | ')
        if (list && list.length > 0) {
          for (const officeName of list) {
            if (officeName === office.chineseName) {
              return true
            }
          }
        }
      }
      return false
    },
    updateJobCooperate(cooperatebranch) {
      this.currentRow.cooperatebranch = cooperatebranch ? cooperatebranch.split(',').join(' | ') : ''
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    }
  }
}
</script>

<style>
.el-dropdown-menu__item.ae-detail-cannot-operate-job {
  pointer-events: none;
  color: rgb(153, 153, 153);
}
</style>
<style lang="scss" scoped>
.el-dropdown-spacing {
  padding-left: 5px;
}
.details-view {
  .btn-group-look.cannot-operate-job::v-deep,
  .tabs-container.cannot-operate-job::v-deep {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
  .btn-group-look.cannot-operate-job::v-deep {
    .el-dropdown.can-operate {
      .el-button {
        &.el-button--primary {
          pointer-events: auto;
          background-color: #1F75D5;
          border-color: #1F75D5;
          &:focus, &:hover {
            background: #4c91dd;
            border-color: #4c91dd;
          }
        }
      }
    }
  }
}
</style>
